let maacboData = [
        {
            "Name of Organization": "English Learning Center - Our Saviour's Community Service",
            "Address": "2315 Chicago Ave. S.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55404",
            "County": "Hennepin",
            "Main phone number": "612-874-9963",
            "Fax Number": "612-871-0017",
            "Organization email": "info@englishlc.org",
            "Organization website": "www.oscs-mn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Jennifer Compton",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "jennifer@englishlc.org",
            "[contact_name]'s phone number": "(612) 871-9963",
            "Second Contact name": "Sandra Aslaksen",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "sandy@oscs-mn.org",
            "[contact_name_2]'s phone number": "612-871-5900",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "We provide free basic English language classes for adult immigrants and refugees who seek literacy services. Once enrolled in English, math, computer and citizenship preparation classes are also available for students. Classes run year round, and are available in the mornings and in the evenings.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Russian Cultural Center Russian Soul",
            "Address": "1624 Third St. N.E.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55413",
            "County": "Hennepin",
            "Main phone number": "612-465-9309",
            "Fax Number": "",
            "Organization email": "info@rusculturemn.com",
            "Organization website": "www.rusculturemn.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Russian-Cultural-Center-Russian- Soul-",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Elena Kallevig",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "info@rusculturemn.com",
            "[contact_name]'s phone number": "612-465-9309",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "European",
            "Please provide a description of services your organization offers": "RCC \"Russian Soul\" is a non-profit organization dedicated to the study, preservation and sharing of Russian folk culture and art and serving as a liaison between Russian speakers and broader community. Our mission also includes assistance to Russian-speaking immigrants and students of Russian.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Women's Initiative for Self Empowerment (WISE), Inc.",
            "Address": "570 Asbury Street, Suite 202",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "651-646-3268",
            "Fax Number": "",
            "Organization email": "admin@womenofwise.org",
            "Organization website": "www.womenofwise.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "womenofwise",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Pamela Zeller",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "pzeller@womenofwise.org",
            "[contact_name]'s phone number": "651-646-3268",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "WISE aims to empower immigrant and refugee women and girls to succeed through academic support and life and leadership skills training so that they can be self-sufficient members of their community and beyond. WISE provides services to women and girls in 6 -12th grade and in college. Services include financial literacy, healthy relationships, selfidentity,  and homework help.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Arrive Ministries",
            "Address": "1515 E. 66th St.",
            "City": "Richfield",
            "State": "MN",
            "Zip Code": "55423",
            "County": "Hennepin",
            "Main phone number": "612-243-2954",
            "Fax Number": "612-798-4314",
            "Organization email": "office@arriveministries.org",
            "Organization website": "www.arriveministries.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "arriveministries",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Anya Yastremski",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "ayastremski@arriveministries.org",
            "[contact_name]'s phone number": "612-243-2954",
            "Second Contact name": "Bob Oehrig",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "boehrig@arriveministries.org",
            "[contact_name_2]'s phone number": "612-243-2954",
            "Please select what communities or groups you serve": "Refugee Resettlement Agency,African (Immigrant)",
            "Please provide a description of services your organization offers": "Employment development plans, job readiness workshops, individual job search and placement services, job retention follow up. Languages: Arabic, Burmese, French, Karen, Russian, Somali, Spanish, Swahili, Thai, Ukrainian",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Council for Minnesotans of African Heritage",
            "Address": "658 Cedar Street, Ste G57",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55155",
            "County": "Ramsey",
            "Main phone number": "651-757-1750",
            "Fax Number": "",
            "Organization email": "shakira.bradshaw@state.mn.us",
            "Organization website": "www.mn.gov/cmah/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "www.facebook.com/cmahmn1/",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Shakira Bradshaw",
            "[contact_name]'s position": "Office Manager",
            "[contact_name]'s email": "shakira.bradshaw@state.mn.us",
            "[contact_name]'s phone number": "651-757-1750",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,Refugee Resettlement Agency",
            "Please provide a description of services your organization offers": "Small State agency responsible for advising the Governor and state Legislature on issues that impact Minnesotans of African Heritage. The mission of the agency focuses on ensuring Minnesotans of African Heritage participate and benefit from the legislative process. The agency does notprovide direct services but does have the ability to connect constituents to state resources.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Catholic Charities, Minneapolis & St. Paul (USCCB)",
            "Address": "1276 University Ave W.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "612-204-8500",
            "Fax Number": "612-664-8555",
            "Organization email": "info@cctwincities.org",
            "Organization website": "www.cctwincities.org/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Catholic-Charities-of-Saint-Paul- and-Minneapolis",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Nancy Granner",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "nancy.granner@cctwincities.org",
            "[contact_name]'s phone number": "612-204-8583",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Catholic Charities of St. Paul and Minneapolis serves those most in need. We are a leader at solving poverty, creating opportunity, and advocating for justice in the community.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Minnesota Councilon Latino Affairs (MCLA) for the State of Minnesota",
            "Address": "658 Cedar Street G56",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55155",
            "County": "Ramsey",
            "Main phone number": "651-757-1762",
            "Fax Number": "651-757-1761",
            "Organization email": "mcla.desk@state.mn.us",
            "Organization website": "www.mn.gov/mcla/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "MinnCLA",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Wendy Sanchez",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "wendy.sanchez1@state.mn.us",
            "[contact_name]'s phone number": "651-757-1762",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "State Council,Latino/Latinx",
            "Please provide a description of services your organization offers": "MCLA is a state agency that advises and educates the government on policy and legislation that pertains to Latinos in Minnesota. It is a bridge of communication between Latinos and the government. It also serves as an information and referral agency to ensure that community members are connected to the appropriate government agencies and community based organizations to address their concerns.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Pillsbury United Communities",
            "Address": "125 W. Broadway Ave. Suite 130",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55411",
            "County": "Hennepin",
            "Main phone number": "612-302-3400",
            "Fax Number": "",
            "Organization email": "Communications@pillsburyunited.org",
            "Organization website": "www.pillsburyunited.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "pucmn",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Adair Mosley",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "adairm@pillsburyunited.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "We are community builders co-creating enduring change toward a just society where every person has personal, social, and economic power. Our united system of programs, neighborhood centers, social enterprises, and partnerships connects individuals and their families across the region. Services include: food access, youth programs, and employment support.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Brian Coyle Neighborhood Center | Pillsbury United Communities",
            "Address": "420 15th Ave. S,",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55454",
            "County": "Hennepin",
            "Main phone number": "712-338-5282",
            "Fax Number": "",
            "Organization email": "Communications@pillsburyunited.org",
            "Organization website": "www.pillsburyunited.org/site/brian-coyle/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "briancoylecenter",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Amano Dube",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "amanod@pillsburyunited.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "We are community builders co-creating enduring change toward a just society where every person has personal, social, and economic power. Our united system of programs, neighborhood centers, social enterprises, and partnerships connects individuals and their families across the region. Services include: immigration support, domestic/sexual violence support, chronic disease management, community wellness, food access, and youth programs. Languages spoken: Amharic, Oromo, Somali",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Oak Park Neighborhood Center | Pillsbury United Communities",
            "Address": "1701 Oak Park Ave. N.,",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55411",
            "County": "Hennepin",
            "Main phone number": "612-377-7000",
            "Fax Number": "612-302-3490",
            "Organization email": "Communications@pillsburyunited.org",
            "Organization website": "www.pillsburyunited.org/site/oak-park",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "oakpark",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Antonio Cardona",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "antonioc@pillsburyunited.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "We are community builders co-creating enduring change toward a just society where every person has personal, social, and economic power. Our united system of programs, neighborhood centers, social enterprises, and partnerships connects individuals and their families across the region. Services include: food access.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Pillsbury House + Theatre | Pillsbury United Communities",
            "Address": "3501 Chicago Ave. S.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55407",
            "County": "Hennepin",
            "Main phone number": "612-824-0708",
            "Fax Number": "",
            "Organization email": "Communications@pillsburyunited.org",
            "Organization website": "www.pillsburyunited.org/site/pillsbury-house",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "PHouseTheatre",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Noel Raymond",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "noelr@pillsburyunited.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "We are community builders co-creating enduring change toward a just society where every person has personal, social, and economic power. Our united system of programs, neighborhood centers, social enterprises, and partnerships connects individuals and their families across the region. Services include: crisis support for families in transition, health outreach and education, early childhood education, and youth arts programs.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Waite House Neighborhood Center | Pillsbury United Communities",
            "Address": "2323 11th Ave. S.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55404",
            "County": "Hennepin",
            "Main phone number": "612-721-1681",
            "Fax Number": "",
            "Organization email": "",
            "Organization website": "www.pillsburyunited.org/site/pillsbury-house",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "waitehouse",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Julie Graves",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "julieg@pillsburyunited.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "We are community builders co-creating enduring change toward a just society where every person has personal, social, and economic power. Our united system of programs, neighborhood centers, social enterprises, and partnerships connects individuals and their families across the region. Services include: food access, youth programs, and employment support.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Croatian Cultural Society of MN",
            "Address": "4119 White Bear Pkwy. Suite 220",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55110",
            "County": "Ramsey",
            "Main phone number": "651-429-6183",
            "Fax Number": "651-429-6079",
            "Organization email": "anovakneumann@comcast.net",
            "Organization website": "www.sites.google.com/site/minnesotacroatians/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "www.facebook.com/ croatianculturalsocietyofminnesota/",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Andrea Novak Neumann",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "anovakneumann@comcast.net",
            "[contact_name]'s phone number": "651-497-1832",
            "Second Contact name": "Dr. Vanca Schrunk",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "idschrunk@sthomas.edu",
            "[contact_name_2]'s phone number": "612-419-7470",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Serves as a source of cultural information for the Minnesotan Croatian Community with a newsletter, cultural events, and Croatian language classes, as well as interpreting services for new immigrants and refugees.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Health Commons - Cedar Riverside",
            "Address": "Chase Building 2nd floor (behind the mailboxes) 1600 S. 6th Street",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55454",
            "County": "Hennepin",
            "Main phone number": "612-273-0112",
            "Fax Number": "612-273-3965",
            "Organization email": "cedarhealthcommons@augsburg.edu",
            "Organization website": "www.augsburg.edu/healthcommons/cedar-riverside/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Health-Commons-at-Cedar- Riverside-",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Diane Tran",
            "[contact_name]'s position": "Coommunity Engagement - Fairview",
            "[contact_name]'s email": "dmtran@healtheast.org",
            "[contact_name]'s phone number": "651-232-4810",
            "Second Contact name": "Rebecca Hartwig",
            "[contact_name_2]'s position": "Augsburn Nursing Department",
            "[contact_name_2]'s email": "hartwigr@augsburg.edu",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Health Commons is a collaborative effort between Augsburg University Nursing Department, Fairview, East African Health  Project, and Peoples Center Health Services. It is a drop-in center offering hospitality, health consultations, bloodpressure checks, exercise, nutrition classes, yoga, massage, healing touch, swimming, and other activities. Anyone is welcome.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Volunteers of America- Minnesota, Culturally Responsive Caregiver Support and Dementia Service",
            "Address": "3333 North 4th Street",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55412",
            "County": "Hennepin",
            "Main phone number": "(952) 945-4034",
            "Fax Number": "",
            "Organization email": "info@voamn.org",
            "Organization website": "www.voamnwi.org/caregiver-support",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "(952)945-4034",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Dorothea Harris",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "dharris@voamn.org",
            "[contact_name]'s phone number": "952-945-4034",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Culturally Responsive Caregiver Support and Dementia Service offers culturally and linguistically appropriate support, information and resources to the community diverse aging population and those that care for them. Services focus on African American, East African and Hmong residents who are facing the challenges of Alzheimer�s Disease and Related Dementias.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Somali Community Resettlement Services",
            "Address": "201 S. Lyndale Ave",
            "City": "Faribault",
            "State": "MN",
            "Zip Code": "55021",
            "County": "Rice",
            "Main phone number": "507-384-3553",
            "Fax Number": "",
            "Organization email": "dyanira@somalcrs.org",
            "Organization website": "www.somalcrs.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Somali-Community-Resettlement-Services",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Abdullah (Sharif) Hared",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "anhared@somalcrs.org",
            "[contact_name]'s phone number": "507-384-3553",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "With offices in Faribault, Rochester, and Minneapolis, SCRS works to improve the well-being of refugees and immigrants by providing community and resettlement services - such as employment programming for low-income and youth, senior supported employment (SCSEP), healthy living, mental health, rights for people with disabilities, suicide prevention, voter registration, and community organization.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "The Advocates for Human Rights",
            "Address": "330 Second Ave. S. Suite 800",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55401",
            "County": "Hennepin",
            "Main phone number": "612-341-3302",
            "Fax Number": "612-341-2971",
            "Organization email": "hrights@advrights.org",
            "Organization website": "www.advrights.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "TheAdvocatesForHumanRights",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Sarah Brenes",
            "[contact_name]'s position": "Director of Refugee and Immigrant Program",
            "[contact_name]'s email": "sbrenes@advrights.org",
            "[contact_name]'s phone number": "612-746-4684",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Organization dedicated to the promotion and protection of internationally recognized human rights. Trained volunteers provide pro bono legal representation, interpretation and translation services to low-income individuals seeking asylum. Clients must be residents of Minnesota, North Dakota or South Dakota and low income. We serve any immigrant seeking asylum, regardless of language.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "African Economic Development Solutions",
            "Address": "1821 University Avenue West Suite S-145",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "(651) 646-9411",
            "Fax Number": "",
            "Organization email": "info@aeds-mn.org",
            "Organization website": "www.aeds-mn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "African Economic Development Solutions (AEDS) of Minnesota",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Gene Gelgelu",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "ggelgelu@aeds-mn.org",
            "[contact_name]'s phone number": "651-646-9411",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "African (Immigrant)",
            "Please provide a description of services your organization offers": "African Economic Development Solutions(AEDS) provides business development training, cultural specific technical assistance, lending, homeownership, financial literacy, and creative placemaking programs(Little Africa cultural Business District) to diverse African immigrant communities.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "The Aliveness Project",
            "Address": "3808 Nicollet Ave.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55409",
            "County": "Hennepin",
            "Main phone number": "612-822-7946",
            "Fax Number": "612-822-9668",
            "Organization email": "info@aliveness.org",
            "Organization website": "www.aliveness.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "AlivenessMN",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Tom Bichnaga",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "tom@aliveness.org",
            "[contact_name]'s phone number": "612-822-7946",
            "Second Contact name": "Matt Toburen",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "matt@aliveness.org",
            "[contact_name_2]'s phone number": "612-822-7946",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Community center providing supportive services for people living with HIV including on-site meals, food shelf, medical/non-medical case management, housing locator, medical nutrition therapy, integrative therapies, and care linkage. Free HIV testing is available. Proof of HIV status required for membership. Services are offered at no cost and there is no income requirements to access services.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Asian Media Access",
            "Address": "2418 Plymouth Ave. N.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55411",
            "County": "Hennepin",
            "Main phone number": "612-376-7715",
            "Fax Number": "612-376-7730",
            "Organization email": "amamedia@amamedia.org",
            "Organization website": "www.amamedia.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Asian-Media-Access-",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Ange Hwang",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "angehwang@amamedia.org",
            "[contact_name]'s phone number": "612-376-7715",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Asian Media Access (AMA) is dedicated to using multimedia arts and technology as tools for social betterment, to connect the dis-connected. Our Organization�s programs are as follows:  1) Multimedia Arts Exhibition/Performance  2) Multimedia Technology Education  3) Multimedia Technology Production",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Assumption Church  / La Mision (Latino Resource Center)",
            "Address": "305 E. 77th St.",
            "City": "Richfield",
            "State": "MN",
            "Zip Code": "55423",
            "County": "Hennepin",
            "Main phone number": "612-866-5019",
            "Fax Number": "612-866-5274",
            "Organization email": "",
            "Organization website": "www.assumptionrichfield.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Church-Of-the-Assumption",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Patricio Pena",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "patricio@assumptionrichfield.org",
            "[contact_name]'s phone number": "612-866-5019",
            "Second Contact name": "Maria del Carmen Salazar",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "maria@assumptionrichfield.org",
            "[contact_name_2]'s phone number": "612-866-5019",
            "Please select what communities or groups you serve": "Latino/Latinx",
            "Please provide a description of services your organization offers": "The Missionary, responds to the  Teaching of the Church. We are dedicated  to improve health, education and well-being,  Human opportunities for young people, adults and families in the Latino community of the  Richfield and Bloomington areas. Help  Latino individuals, families and children  connect them to the existing community  agencies that provide spiritual, medical,  educational and support services",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Welcome Center, Inc",
            "Address": "316 N. Main St., Ste 101",
            "City": "Austin",
            "State": "MN",
            "Zip Code": "55912",
            "County": "Mower",
            "Main phone number": "507-434-2863",
            "Fax Number": "507-434-2868",
            "Organization email": "director@austinwelcomecenter.org",
            "Organization website": "www.austinwelcomecenter.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "welcomecenter",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Herve Idjidina",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "director@austinwelcomecenter.org",
            "[contact_name]'s phone number": "507-434-2863",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "The Welcome Center provides assistance to all new residents of Austin, especially minorities who are highly susceptible to various forms of distress due to their ethnic backgrounds, cultural differences and language barriers. Our  mission is “Empowering diverse community engagement trough guidance and connections”.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Avivo",
            "Address": "1900 Chicago Avenue",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55404",
            "County": "Hennepin",
            "Main phone number": "612-752-8800",
            "Fax Number": "612-752-8801",
            "Organization email": "contact@avivomn.org",
            "Organization website": "www.avivomn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "AvivoMN",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Kim Sheagren",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "kim.sheagren@avivomn.org",
            "[contact_name]'s phone number": "612-752-8029",
            "Second Contact name": "Aaron Shaffer",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "aaron.shaffer@avivomn.org",
            "[contact_name_2]'s phone number": "612-752-8591",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Avivo provides chemical and mental health services, career education, and employment services for women, men, and families in the Twin Cities metro and central Minnesota. We specialize in serving low-income families and individuals with the greatest barriers to recovery, health, housing, employment, and economic stability. We offer 25 locations and serve residents in 17 counties.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Asian Women United of  Minnesota (AWUM)",
            "Address": "P.O. Box 6223",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55406",
            "County": "Hennepin",
            "Main phone number": "612-724-0756",
            "Fax Number": "612-729-0660",
            "Organization email": "awum@awum.org",
            "Organization website": "www.awum.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Asian-Women-United-of- Minnesota-AWUM-",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Nancy Wong",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "awum@awum.org",
            "[contact_name]'s phone number": "612-724-0756",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,Refugee Resettlement Agency",
            "Please provide a description of services your organization offers": "Domestic Violence services: 24 hour multilingual crisis line; 24 hour emergency shelter for women and their children; legal advocacy; immigration assistance; orders for  protection, harassment restraining orders; support groups; community advocacy and education/training.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Minnesota Brain Injury Alliance",
            "Address": "2277 Hwy. 36 W. Suite 200",
            "City": "Roseville",
            "State": "MN",
            "Zip Code": "55113",
            "County": "Ramsey",
            "Main phone number": "612-378-2742",
            "Fax Number": "612-378-2789",
            "Organization email": "info@braininjurymn.org",
            "Organization website": "www.braininjurymn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Minnesota Brain Injury Alliance",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Sara Schlegelmilch",
            "[contact_name]'s position": "Chief Program Officer",
            "[contact_name]'s email": "saras@braininjurymn.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Mission is to raise awareness and enhance the quality of life for all people affected by brain injury. They serve all communities and have staff that speak English, Spanish, Hmong, French and Chinese.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "CAPI USA (Formerly Center for Asian & Pacific Islanders)",
            "Address": "5930 Brooklyn Blvd and 3702 E. Lake Street Suite 200",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55406",
            "County": "Hennepin",
            "Main phone number": "612-721-0122",
            "Fax Number": "",
            "Organization email": "info@capiusa.org",
            "Organization website": "www.capiusa.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "CAPIUSA1982",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Leila Hussain",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "leila.hussain@capiusa.org",
            "[contact_name]'s phone number": "612-767-3682",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "CAPI's mission is to guide refugees, immigrants, and U.S. born people in their journey toward self-determination and social equality. CAPI programs include basic needs services (food and nutrition, public assistance enrollment, senior programming), economic empowerment (career pathways trainings, employment services and job search assistance, wealth and asset building), and civic engagement.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Catholic Charities of the Diocese of Winona",
            "Address": "903 W. Center St. Suite 220",
            "City": "Rochester",
            "State": "MN",
            "Zip Code": "55902",
            "County": "Olmsted",
            "Main phone number": "507-287-2047",
            "Fax Number": "507-287-2050",
            "Organization email": "info@ccsomn.org",
            "Organization website": "www.ccsomn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Catholic Charities of Southern Minnesota",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Sheila Collom",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "scollom@ccsomn.org",
            "[contact_name]'s phone number": "507-454-2270",
            "Second Contact name": "Kristina Hammell",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "khammell@ccsomn.org",
            "[contact_name_2]'s phone number": "507-287-2047",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "The Refugee Resettlement Program works with refugees from various parts of the world (Iraq, Somali, Syria, Ethiopia, Sudan, etc.) for 90 days beginning with their arrival in Rochester, but even before that we have secured, and furnished, safe and stable housing for them. Within the 90 days we connect our families with the “building blocks” they need to eventually achieve self-sufficiency and financial stability: including proper documents, access to health care, education for children and adults, employment, food security, financial literacy, and cultural orientations. Working with over 25 area community service providers we begin equipping our families with the knowledge and skills needed to become self-sufficient and empowered. Our on staff case managers speak various languages which include: Arabic, Somali, Swahili, and French.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Greater Minneapolis Council of Churches (GMCC)  Center for Families",
            "Address": "3333 N. Fourth St.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55412",
            "County": "Hennepin",
            "Main phone number": "612-276-1530",
            "Fax Number": "612-276-1531",
            "Organization email": "centerforfamilies@gmcc.org",
            "Organization website": "www.centerforfamilies.gmcc.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Adrienne Dorn",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "adorn@gmcc.org",
            "[contact_name]'s phone number": "651-336-6838",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "The GMCC Center for Families no longer exists and should be taken out of the directory.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Central Minnesota Legal Services (Serving Hennepin and Anoka counties)",
            "Address": "111 North 5th Street, Suite 402",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55403",
            "County": "Hennepin",
            "Main phone number": "(612) 334-5970",
            "Fax Number": "(612) 334-3402",
            "Organization email": "",
            "Organization website": "www.centralmnlegal.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "CentralMinnesotaLegalServices",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Jean Lastine",
            "[contact_name]'s position": "Executive Director (Minneapolis)",
            "[contact_name]'s email": "jlastine@centralmnlegal.org",
            "[contact_name]'s phone number": "(612) 332-8151",
            "Second Contact name": "Dan Morris",
            "[contact_name_2]'s position": "Managing Attorney (St. Coud and Willmar)",
            "[contact_name_2]'s email": "dmorris@centralmnlegal.org",
            "[contact_name_2]'s phone number": "(320) 253-0138",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Provides free civil legal services to people with low incomes in central Minnesota, with offices in Minneapolis, St. Cloud, and Willmar. Services range from outreach and educational seminars to direct client assistance, advice, brief legal services, and representation in court. Legal issues include divorce, custody, domestic abuse, employment, housing and criminal expungement, public benefits, debt collection, and housing matters.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Central Minnesota Legal Services (Serving Benton, Chisago, Isanti, Mille Lacs, Morrison, Sherburne, Stearns, Todd, and Wright counties)",
            "Address": "110 Sixth Ave South, Suite 205",
            "City": "St. Cloud",
            "State": "MN",
            "Zip Code": "56301",
            "County": "Stearns",
            "Main phone number": "(320) 253-0121",
            "Fax Number": "(320) 253-9208",
            "Organization email": "",
            "Organization website": "www.centralmnlegal.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "CentralMinnesotaLegalServices",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Jean Lastine",
            "[contact_name]'s position": "Executive Director (Minneapolis)",
            "[contact_name]'s email": "jlastine@centralmnlegal.org",
            "[contact_name]'s phone number": "(612) 332-8152",
            "Second Contact name": "Dan Morris",
            "[contact_name_2]'s position": "Managing Attorney (St. Coud and Willmar)",
            "[contact_name_2]'s email": "dmorris@centralmnlegal.org",
            "[contact_name_2]'s phone number": "(320) 253-0139",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Provides free civil legal services to people with low incomes in central Minnesota, with offices in Minneapolis, St. Cloud, and Willmar. Services range from outreach and educational seminars to direct client assistance, advice, brief legal services, and representation in court. Legal issues include divorce, custody, domestic abuse, employment, housing and criminal expungement, public benefits, debt collection, and housing matters.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Central Minnesota Legal Services (Serving Big Stone, Chippewa, Kandiyohi, Lac Qui Parle, Lincoln, Lyon, Meeker, Renville, Swift, and Yellow Medicine counties)",
            "Address": "415 Seventh St. SW, Suites 101",
            "City": "Willmar",
            "State": "MN",
            "Zip Code": "56201",
            "County": "Kandiyohi",
            "Main phone number": "(320) 235-9600",
            "Fax Number": "(320) 235-9496",
            "Organization email": "",
            "Organization website": "www.centralmnlegal.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "(888) 360-3666",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "CentralMinnesotaLegalServices",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Jean Lastine",
            "[contact_name]'s position": "Executive Director (Minneapolis)",
            "[contact_name]'s email": "jlastine@centralmnlegal.org",
            "[contact_name]'s phone number": "(612) 332-8153",
            "Second Contact name": "Dan Morris",
            "[contact_name_2]'s position": "Managing Attorney (St. Coud and Willmar)",
            "[contact_name_2]'s email": "dmorris@centralmnlegal.org",
            "[contact_name_2]'s phone number": "(320) 253-0140",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Provides free civil legal services to people with low incomes in central Minnesota, with offices in Minneapolis, St. Cloud, and Willmar. Services range from outreach and educational seminars to direct client assistance, advice, brief legal services, and representation in court. Legal issues include divorce, custody, domestic abuse, employment, housing and criminal expungement, public benefits, debt collection, and housing matters.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Civil Society",
            "Address": "1595 Selby Avenue, Suite 112",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "651-291-0713",
            "Fax Number": "",
            "Organization email": "office@civilsocietyhelps.org",
            "Organization website": "www.civilsocietyhelps.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Civil-Society helps",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Linda Miller",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "linda.miller@civilsocietyhelps.org",
            "[contact_name]'s phone number": "651-291-0713",
            "Second Contact name": "Sachiko Kudoh",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "sachiko.k@civilsocietyhelps.org",
            "[contact_name_2]'s phone number": "651-291-0713",
            "Please select what communities or groups you serve": "Multicultural,Refugee Resettlement Agency",
            "Please provide a description of services your organization offers": "Civil Society, a Minnesota-based nonprofit organization, provides culturally and linguistically specific, direct traumainformed  comprehensive legal services to victims of human trafficking (labor and sex), sexual assault, domestic abuse, dating violence, stalking, and child sex tourism.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "CLUES (Comunidades Latinas Unidas En Servicio)",
            "Address": "797 E. Seventh St.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55106",
            "County": "Ramsey",
            "Main phone number": "651-379-4200",
            "Fax Number": "651-292-0347",
            "Organization email": "info@clues.org",
            "Organization website": "www.clues.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "CLUESPage",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Ruby Azurdia-Lee",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "rlee@clues.org",
            "[contact_name]'s phone number": "651-379-4203",
            "Second Contact name": "Dale Dufault",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "ddufault@clues.org",
            "[contact_name_2]'s phone number": "651-379-4259",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "CLUES has Mental and Chemical Health clinics that provide assessment and therapy services. We have an Elder Day Center to provide Elder Care and Caregiver Support  services. We have an employment and career development division to assist clients in securing employment or increasing wages. We have a Teen Tech Center to provide  technology training to Youth. We provide Health and Parenting education.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Consulado de Mexico en Saint Paul, Minnesota/ Consulate of Mexico in Saint Paul, Minnesota",
            "Address": "797 E. Seventh St.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55106",
            "County": "Ramsey",
            "Main phone number": "651-771-5494",
            "Fax Number": "651-772-4419",
            "Organization email": "contacto@consulmexstpaul.com",
            "Organization website": "www.consulmex.sre.gob.mx/ saintpaul/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Consulmex Saint Paul",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Mónica Cruz",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "mcruz@consulmexstpaul.com",
            "[contact_name]'s phone number": "651-771-5494",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Latino/Latinx",
            "Please provide a description of services your organization offers": "Programs and services in Documentation (passports, Consular ID card, civil registry, powers of attorney); Protection (legal assistance and referrals, financial aid); Community Affairs (education, financial literacy, a health reference center providing screenings and referrals to free or low cost providers). Some services are limited to Mexicans, most are available for anyone regardless of origin.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "EMERGE Community Development",
            "Address": "1834 Emerson Ave N",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55411",
            "County": "Hennepin",
            "Main phone number": "612-529-9267",
            "Fax Number": "",
            "Organization email": "info@emerge-mn.org",
            "Organization website": "www.emerge-mn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "emergecommunitydevelopment",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Jill Pearson-Wood",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "pearsonwoodj@emerge-mn.org",
            "[contact_name]'s phone number": "612-787-3791",
            "Second Contact name": "Linda Bryant",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "bryantl@emerge-mn.org",
            "[contact_name_2]'s phone number": "612-787-3786",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "EMERGE is a community and workforce development organization with a mission “to reveal the potential in people and communities through skill building, employment, and economic opportunity.” This reflects our commitment to both facilitate life change for individuals facing significant obstacles, and to create systemic change at the community level.  Operating in N Mpls and Cedar-Riverside.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "East Side Neighborhood Services",
            "Address": "1700 Second St. N.E.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55413",
            "County": "Hennepin",
            "Main phone number": "612-781-6011",
            "Fax Number": "",
            "Organization email": "agencyinfo@esns.org",
            "Organization website": "www.esns.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "ESNeighborhood",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Kristine Martin",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "kmartin@esns.org",
            "[contact_name]'s phone number": "612-787-4011",
            "Second Contact name": "Jay Ross",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "pr@esns.org",
            "[contact_name_2]'s phone number": "612-787-4063",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "We provide a holistic range of social services across Hennepin County including childcare, afterschool programming, summer camp, alternative high school, employment services from youth through older adults, foodshelves, caregiving support services, and older adult transportation services.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Goodwill Easter Seals Minnesota",
            "Address": "553 Fairview Ave. N.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "651-379-5800",
            "Fax Number": "",
            "Organization email": "",
            "Organization website": "www.gesmn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Goodwill Easter-Seals Minnesota",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Community Resource Specialist",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "programaccess@gesmn.org",
            "[contact_name]'s phone number": "651-379-5603",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Every person has a right to participate in the world of work; we can help overcome the barriers that prevent you from reaching your goals for work, education and independence. We offer job search and placement services, job support, employment training and direction to help you advance in a career.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Hands Across the World",
            "Address": "1605 Goettens Way  Suite 206    School Site Mary Center 823 First St. S.",
            "City": "St. Cloud",
            "State": "MN",
            "Zip Code": "56301",
            "County": "Stearns",
            "Main phone number": "320-260-1072",
            "Fax Number": "320-217-8809",
            "Organization email": "info@handsacrosstheworldmn.org",
            "Organization website": "www.handsacrosstheworldmn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "handsacrosstheworldmn",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Brianda Cediel",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "info@handsacrosstheworldmn.org",
            "[contact_name]'s phone number": "320-260-1072",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,Refugee Resettlement Agency",
            "Please provide a description of services your organization offers": "Located in St. Cloud, Hands Across the World provides the first learning experience to newly arrived immigrants and refugees who do not have language or living skills necessary to thrive in a new community. Child care provided.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Hmong American Partnership Arcade Office (Main)",
            "Address": "1075 Arcade St.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55106",
            "County": "Ramsey",
            "Main phone number": "651-495-9160",
            "Fax Number": "651-495-1699",
            "Organization email": "frontdesk@hmong.org",
            "Organization website": "www.hmong.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "HmongAmericanPartnership",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Bao Vang",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "baov@hmong.org",
            "[contact_name]'s phone number": "651-495-1507",
            "Second Contact name": "Derlee Moua",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "derleem@hmong.org",
            "[contact_name_2]'s phone number": "651-495-1601",
            "Please select what communities or groups you serve": "Multicultural,Refugee Resettlement Agency",
            "Please provide a description of services your organization offers": "HAP is a nonprofit organization focused on empowering the refugee and immigrant community by moving our clients out of poverty and towards social and financial prosperity. We assist refugees and permanent residents in improving job skills and placement; access to health care, youth programs, community and economic development.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Hmong Cultural Center of Minnesota",
            "Address": "375 University Avenue, Suite 204",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55101",
            "County": "Ramsey",
            "Main phone number": "651-769-4670",
            "Fax Number": "651-917-9978",
            "Organization email": "pfeifem@sunyit.edu",
            "Organization website": "www.hmongcc.org/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "HmongCulturalCenter",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Txong Pao Lee",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "txong@hmongcc.org",
            "[contact_name]'s phone number": "651-917-9937",
            "Second Contact name": "Dr. Mark Pfeifer",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "markpfeifer@hmongcc.org",
            "[contact_name_2]'s phone number": "651-917-9937",
            "Please select what communities or groups you serve": "Asian and Pacific Islander",
            "Please provide a description of services your organization offers": "Cultural Arts Education, Adult Basic Education, Multicultural Education. English and Citizenship Classes for immigrant and  refugee adults, Hmong Folk Arts classes, Hmong Resource Library, Interactive Hmong Museum, Group Tours about Hmong Culture and History.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "International Institute  of Minnesota",
            "Address": "1694 Como Ave.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55108",
            "County": "Ramsey",
            "Main phone number": "651-647-0191",
            "Fax Number": "651-647-9268",
            "Organization email": "info@iimn.org",
            "Organization website": "www.iimn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "IIMN.COMO",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Micaela Schuneman",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "MSchuneman@iimn.org",
            "[contact_name]'s phone number": "(651) 377-8110",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,Refugee Resettlement Agency",
            "Please provide a description of services your organization offers": "The International Institute of Minnesota is an organization committed to helping immigrants and refugees achieve full membership in American life. For 100 years, the Institute has helped New Americans successfully transition to life in Minnesota. Through employment services, refugee services, immigration assistance and English-language education, the  Institute empowers New Americans to thrive",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Immigrant Law Center of Minnesota",
            "Address": "450 N Syndicate St., Suite 200",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "651-641-1011",
            "Fax Number": "",
            "Organization email": "oficinalegal@ilcm.org",
            "Organization website": "www.ilcm.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "immigrantlawcenterMN",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Jenny Stohl Powell",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "jenny.stohpowelll@ilcm.org",
            "[contact_name]'s phone number": "651-641-1011",
            "Second Contact name": "Melissa Pfeiffer",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "melissa.pfeiffer@ilcm.org",
            "[contact_name_2]'s phone number": "651-641-1011",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "An organization dedicated to providing comprehensive immigration legal services to low-income clients of all nationalities. We also have offices in Worthington, Austin,  and Moorhead, MN, as well as a second office at Neighborhood House in St. Paul.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "St. Paul Jewish Federation",
            "Address": "790 S. Cleveland Ave. Suite 227",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55116",
            "County": "Ramsey",
            "Main phone number": "651-690-1707",
            "Fax Number": "",
            "Organization email": "webmaster@stpaulfed.org",
            "Organization website": "www.jewishstpaul.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "jewishstpaul",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Mark Adelman",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "markjayadelman@gmail.com",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "European",
            "Please provide a description of services your organization offers": "Enhances and sustains the St. Paul and overseas Jewish communities through financial resource development and planning, and by working in partnership with social service agencies, educational institutions, and synagogues.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Jewish Family & Children's Services of Minneapolis",
            "Address": "5905 Golden Valley Rd",
            "City": "Golden Valley",
            "State": "MN",
            "Zip Code": "55422",
            "County": "Hennepin",
            "Main phone number": "952-546-0616",
            "Fax Number": "952-593-1778",
            "Organization email": "jfcs@jfcsmpls.org",
            "Organization website": "www.jfcsmpls.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "jfcsminneapolis",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Social service agency serving people from all backgrounds in Hennepin County, providing over 40 programs including mental health, financial, vocational, disability and aging services.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Jewish Family Service of St. Paul",
            "Address": "1633 W. Seventh St.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55102",
            "County": "Ramsey",
            "Main phone number": "651-698-0767",
            "Fax Number": "651-698-0162",
            "Organization email": "info@jfssp.org",
            "Organization website": "www.jfssp.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "jfssp",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Tim Gothmann",
            "[contact_name]'s position": "Assitant Director",
            "[contact_name]'s email": "tgothmann@jfssp.org",
            "[contact_name]'s phone number": "651-698-0767",
            "Second Contact name": "Miriam Feingold",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "mfeingold@jfssp.org",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Jewish Family Service of St. Paul serves anyone in the East Metropolitan area. Services provided include Counseling, Case Management, Emergency Assistance, Chaplaincy, and Employment.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Korean Service Center",
            "Address": "630 Cedar Ave. S. #B1",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55454",
            "County": "Hennepin",
            "Main phone number": "612-342-1345",
            "Fax Number": "612-342-1341",
            "Organization email": "yoonjupark@kscmn.org",
            "Organization website": "www.kscmn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "koreanservicemn",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Yoonju Park",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "yoonjupark@kscmn.org",
            "[contact_name]'s phone number": "612-998-1402",
            "Second Contact name": "Kwangja Kwon",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "kwonksc@gmail.com",
            "[contact_name_2]'s phone number": "612-342-1344",
            "Please select what communities or groups you serve": "Asian and Pacific Islander",
            "Please provide a description of services your organization offers": "Culturally specific long-term care services for Asian older adults, mostly Koreans and Chinese. The long-term care services include Assisted Living ( Comprehensive home Care), Home Management Services, Congregate Dining,  Transportation, Caregiver Support Services and Access Services.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Lifetrack Resources, Inc.",
            "Address": "709 University Ave. W.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "651-227-8471",
            "Fax Number": "651-227-0621",
            "Organization email": "mail@lifetrack-mn.org",
            "Organization website": "www.lifetrack-mn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "lifetrackmn",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Amy Runk",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "amyr@lifetrack-mn.org",
            "[contact_name]'s phone number": "612-787-2302",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "One-on-one job search assistance for immigrants and refugees with a disability. Customer Service credential/certificate available at Lifetrack through Century College for our clients in this program.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Lutheran Social Service of Minnesota - St. Cloud",
            "Address": "22 Wilson Ave. N.E. Suite 110",
            "City": "St. Cloud",
            "State": "MN",
            "Zip Code": "56304",
            "County": "Sherburne",
            "Main phone number": "320-251-7700",
            "Fax Number": "320-251-8898",
            "Organization email": "refugee.services@lssmn.org",
            "Organization website": "www.lssmn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "LSSMNRefugees",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Yusuf Abdi",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "yusuf.abdi@lssmn.org",
            "[contact_name]'s phone number": "612-879-5258",
            "Second Contact name": "Karin Blythe",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "karin.blythe@lssmn.org",
            "[contact_name_2]'s phone number": "320-251-7700",
            "Please select what communities or groups you serve": "Multicultural,Refugee Resettlement Agency",
            "Please provide a description of services your organization offers": "Provides refugee resettlement and placement services, immigration, Refugee Cash Assistance (RCA), Refugee Employment Services (RES), and assists secondary refugees.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Minnesota Council of Churches, Mankato Area Refugee  Services",
            "Address": "501 S. Second Street",
            "City": "Mankato",
            "State": "MN",
            "Zip Code": "56001",
            "County": "Blue Earth",
            "Main phone number": "507-345-1554",
            "Fax Number": "507-345-1556",
            "Organization email": "rsmankato@mnchurches.org",
            "Organization website": "www.mnchurches.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "mcc.mankato",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Habiba Rashid",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "habiba.rashid@mnchurches.org",
            "[contact_name]'s phone number": "507-550-1704",
            "Second Contact name": "Nancy Altmann",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "nancy.altmann@mnchurches.org",
            "[contact_name_2]'s phone number": "507-550-1713",
            "Please select what communities or groups you serve": "Refugee Resettlement Agency,African (Immigrant)",
            "Please provide a description of services your organization offers": "Supports refugees and former refugees as they seek to establish lives full of hope and opportunity in and around Mankato. We support refugee community integration and transition to self-sufficiency though case management, job placement, immigration adjustment, and community engagement and outreach services.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Minnesota Council of Churches",
            "Address": "122 W Franklin Ave. Suite #100",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55404",
            "County": "Hennepin",
            "Main phone number": "612-874-8605",
            "Fax Number": "612-870-3622",
            "Organization email": "mcc@mnchurches.org",
            "Organization website": "www.mnchurches.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "mcc.refugeeservices",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Ben Walen",
            "[contact_name]'s position": "Division Director: Refugee Services",
            "[contact_name]'s email": "ben.walen@mnchurches.org",
            "[contact_name]'s phone number": "612-230-3215",
            "Second Contact name": "Nina Vang",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "nina.vang@mnchurches.org",
            "[contact_name_2]'s phone number": "612-230-3224",
            "Please select what communities or groups you serve": "Multicultural,Refugee Resettlement Agency",
            "Please provide a description of services your organization offers": "MCC Refugee Services provides resettlement, health case management, employment, education and immigration legal services to refugees, asylees and others with a humanitarian protection immigration status. We work to engage community members, faith groups and volunteers in this work, to create a community that welcomes refugees into hope and opportunity.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Minnesota Literacy Council",
            "Address": "700 Raymond Ave. Suite 180",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55114",
            "County": "Ramsey",
            "Main phone number": "651-645-2277",
            "Fax Number": "651--645-2272",
            "Organization email": "email@mnliteracy.org",
            "Organization website": "www.mnliteracy.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "mnliteracy",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Kirsten Collins",
            "[contact_name]'s position": "Literary Services Program Director",
            "[contact_name]'s email": "kcollins@mnliteracy.org",
            "[contact_name]'s phone number": "651-251-9068",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Minnesota Literacy Council provides free Adult Basic Education classes (ESL, citizenship, GED, computers) in the Twin Cities, a referral service to connect adults with hundreds of free classes across Minnesota (CALL 800-222-1990, TEXT 612-424-1211, SEARCH http://mnliteracy.org/hotline), and training/support for volunteers working with adults/children to improve their English and academic skills.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "MORE",
            "Address": "96 E. Wheelock Prky.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55117",
            "County": "Ramsey",
            "Main phone number": "651-487-2728",
            "Fax Number": "651-528-6132",
            "Organization email": "info@more-empowerment.org",
            "Organization website": "www.more-empowerment.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "MOREMinnesota",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Moo Ra Paw",
            "[contact_name]'s position": "Programs coordinator",
            "[contact_name]'s email": "mpaw@more-empowerment.org ",
            "[contact_name]'s phone number": "651-204-0342",
            "Second Contact name": "Cathy Rucci",
            "[contact_name_2]'s position": "Executive Director",
            "[contact_name_2]'s email": "crucci@more-empowerment.org",
            "[contact_name_2]'s phone number": "651-204-0497",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "MORE provides refugees and immigrants with the education and support they seek  to become fully engaged members of our community. MORE�s services focus on adults in two  program areas: Education/Free English Classes and Social Services that include case management/advocacy and basic needs services.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Mid-Minnesota Legal Aid",
            "Address": "110 6th Ave. S., Suite 200",
            "City": "St. Cloud",
            "State": "MN",
            "Zip Code": "56301",
            "County": "Stearns",
            "Main phone number": "320-257-4860",
            "Fax Number": "",
            "Organization email": "ACOFELL@MYLEGALAID.ORG",
            "Organization website": "www.mylegalaid.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "LegalAid",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Ann Cofell",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "acofell@mylegalaid.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Provides free civil legal services to people with low incomes in central Minnesota through offices in Minneapolis, St. Cloud, and Willmar. Services range from educating clients about their rights, to advocating  on their behalf and representing clients  in court. Evictions and landlord abuse, foreclosure rights, public and Section 8 housing, housing discrimination, denial of public benefits, divorce, child custody and support, domestic abuse, disability, debt collection and unfair loans, immigration, and youth- and elder-related issues.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "NAVIGATE MN",
            "Address": "1515 E Lake St",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55407",
            "County": "Hennepin",
            "Main phone number": "763-301-1459",
            "Fax Number": "",
            "Organization email": "team@navigatemn.org",
            "Organization website": "www.navigatemn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "NAVIGATE.MN",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Emilia",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "emilia@navigatemn.org",
            "[contact_name]'s phone number": "763-301-1459",
            "Second Contact name": "Estefania Navarro",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "estefania@navigatemn.org",
            "[contact_name_2]'s phone number": "651-276-8726",
            "Please select what communities or groups you serve": "Latino/Latinx",
            "Please provide a description of services your organization offers": "Navigate MN is latinx organization that builds power in our community around issues of education, immigration and environmental justice. We provide low-income immigrant families services ranging from financial aid application, know-your-rights training, after school youth programming, scholarship application support, civic engagement to leadership development for young adults.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "RISE, Inc.",
            "Address": "3708 Nicollet Ave.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55409",
            "County": "Hennepin",
            "Main phone number": "612-872-7720",
            "Fax Number": "612-872-7679",
            "Organization email": "info@rise.org",
            "Organization website": "www.rise.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Rise.Incorporated",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Truc Pham",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "tpham@rise.org",
            "[contact_name]'s phone number": "612-872-7720",
            "Second Contact name": "Nichol Ellis-McGrego",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "NEllis-McGregor@rise.org",
            "[contact_name_2]'s phone number": "612-872-7720",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "This program provides job placement services for MFIP recipients living in Hennepin County who are unemployed and are having a difficult time re-entering the job market. Many employment consultants are bilingual including: Spanish, Somali, Hmong, and Vietnamese. Employment services are matched to each individual's own career goals and plans. Linkages to other services are provided.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Cedar Riverside Adult Education Collaborative",
            "Address": "1515 S. Fourth St.  Box 2009",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55454",
            "County": "Hennepin",
            "Main phone number": "612-376-0619",
            "Fax Number": "612-376-0695",
            "Organization email": "snurie@riversideplazata.net",
            "Organization website": "www.riversideplazata.org/esl_ program",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Seyou Nurie",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "snurie@riversideplazata.net",
            "[contact_name]'s phone number": "612-376-0619",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,Refugee Resettlement Agency",
            "Please provide a description of services your organization offers": "Cedar Riverside Adult Education Collaborative (CRAEC) was founded to serve Riverside Plaza tenants as well as English language learners in the surrounding area.The majority of the residents are immigrants and refugees from East Africa, mostly from Somalia and Ethiopia.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Safe Place: Homework Help",
            "Address": "2001 Riverside Ave.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55454",
            "County": "Hennepin",
            "Main phone number": "612-333-2561",
            "Fax Number": "",
            "Organization email": "tutoring@trinitylutherancongregation. org",
            "Organization website": "www.safeplacehomeworkhelp.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Jane Buckley Farlee",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "pastorjane@trinitylutherancongregation.org",
            "[contact_name]'s phone number": "612-333-2561",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Trinity Lutheran Congregation offers “Safe Place: Homework Help” to provide supervised tutoring to students in the Cedar-Riverside neighborhood. Safe Place provides a welcoming atmosphere with tutors ready to assist students of all ages from kindergarten to adult. Although many students are of East African descent, students of any ethnicity are welcome.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "SEWA-AIFW Inc",
            "Address": "3702 E. Lake St. Suite 300",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55406",
            "County": "Hennepin",
            "Main phone number": "763-234-8301",
            "Fax Number": "855-846-8544",
            "Organization email": "info@sewa-aifw.org",
            "Organization website": "www.sewa-aifw.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "952-912- 9100",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Raj Chaudhary",
            "[contact_name]'s position": "Chief Operating Officer",
            "[contact_name]'s email": "Raj@sewa-aifw.org",
            "[contact_name]'s phone number": "763-234-8301",
            "Second Contact name": "Dasharatha yata",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "Dasharath@sewa-aifw.org",
            "[contact_name_2]'s phone number": "952-258-3096",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Sewa serves the South ASIAN vulnerable underserved  populations in a culturally specific way.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Sierra Leone Community in Minnesota",
            "Address": "16 Cutler Street",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55119",
            "County": "Ramsey",
            "Main phone number": "612-990-5294",
            "Fax Number": "",
            "Organization email": "",
            "Organization website": "www.slcmn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Jonathan Rose",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "jrose1@mmm.com",
            "[contact_name]'s phone number": "612-990-5294",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "African (Immigrant)",
            "Please provide a description of services your organization offers": "SLCM is an umbrella organization that pools resources together to help smaller Sierra Leonean organizations in the Twin Cities area. SLCM is a leader in the  community of people of African descent in working to reduce tobacco harm, providing education on healthy living, and serving as a link between various country organizations.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Southern Regional Legal",
            "Address": "450 North Syndicate Street, Suite 285",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "651-291-2837",
            "Fax Number": "651-645-0757",
            "Organization email": "rims@smrls.org",
            "Organization website": "www.smrls.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Lou Her",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "lou.her@smrls.org",
            "[contact_name]'s phone number": "651-894-6853",
            "Second Contact name": "Xer Xiong",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "xer.xiong@smrls.org",
            "[contact_name_2]'s phone number": "651-291-2837",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Provides high quality immigration legal services to low income immigrants and refugees in the east metro and southern Minnesota.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "SMRLS Agricultural Worker Project/Proyecto para Trabajadores Agricolas - Moorhead",
            "Address": "1015 7th Avenue North",
            "City": "Moorhead",
            "State": "MN",
            "Zip Code": "56560",
            "County": "Clay",
            "Main phone number": "888-575-2954",
            "Fax Number": "",
            "Organization email": "awp@smrls.og",
            "Organization website": "www.smrls.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Agricultural Worker Project (AgWProject)",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Griselt Andrade",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "griselt.andrade@smrls.org",
            "[contact_name]'s phone number": "701-232-8872",
            "Second Contact name": "Mario Solis",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "mario.solis@smrls.org",
            "[contact_name_2]'s phone number": "701-212-2642",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Legal representation and education to settled and migrant agricultural workers in Minnesota and North Dakota who encounter wage theft, contract violations, health and safety concerns, discrimination/retaliation, problems with employer-provided housing, labor trafficking and more. Agricultural work includes field work, cannery work, H-2A work, H-2B forestry work, nursery work, and livestock work.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "SMRLS Agricultural Worker Project/Proyecto para Trabajadores Agricolas - St. Paul",
            "Address": "55 East 5th Street, Suite 1000",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55101",
            "County": "Ramsey",
            "Main phone number": "651-894-6854",
            "Fax Number": "651-228-9450",
            "Organization email": "awp@smrls.org",
            "Organization website": "www.smrls.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Agricultural Worker Project (AgWProject)",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Gracia Johnson",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "gracia.johnson@smrls.org",
            "[contact_name]'s phone number": "651-894-6976",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Legal representation and education to settled and migrant agricultural workers in Minnesota and North Dakota who encounter wage theft, contract violations, health and safety concerns, discrimination/retaliation, problems with employer-provided housing, labor trafficking and more. Agricultural work includes field work, cannery work, H-2A work, H-2B forestry work, nursery work, and livestock work.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "SW Adult Basic Education Marshall Region",
            "Address": "1501 N State Street, SMSU, SS Bldg 118",
            "City": "Marshall",
            "State": "MN",
            "Zip Code": "56258",
            "County": "Lyon",
            "Main phone number": "507-537-7046",
            "Fax Number": "507-537-7047",
            "Organization email": "dawn.boerboom@marshall.k12.mn.us",
            "Organization website": "www.southwestabe.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Southwest Adult Basic Education",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "See Moua-Leske",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "see.moua-leske@marshall.k12.mn.us",
            "[contact_name]'s phone number": "507-537-7046",
            "Second Contact name": "Jenna Weyer",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "jenna.weyer@marshall.k12.mn.us",
            "[contact_name_2]'s phone number": "507-537-7046",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Offers: Computer, Citizenship, ESL, GED/College ready and Family Literacy classes. In association with the SW CAREER FORCE, we also offer CDL, CNA, and Welding classes with educational support to help make sure students succeed.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Teatro de Pueblo",
            "Address": "209 W. Page St. Suite 213",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55107",
            "County": "Ramsey",
            "Main phone number": "651-224-8806",
            "Fax Number": "651-298-5796",
            "Organization email": "teatromn@gmail.com",
            "Organization website": "www.teatrodelpueblo.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "651-225-8106",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "TeatroMN",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Alberto Justiniano",
            "[contact_name]'s position": "Artistic Director",
            "[contact_name]'s email": "al@teatrodelpueblo.org",
            "[contact_name]'s phone number": "651-224-8806",
            "Second Contact name": "Claire Frederick",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "teatromn@gmail.com",
            "[contact_name_2]'s phone number": "651-224-8806",
            "Please select what communities or groups you serve": "Latino/Latinx",
            "Please provide a description of services your organization offers": "Teatro del Pueblo is a Latino theater located in St. Paul’s W. side. Teatro del Pueblo promotes Latino culture through the creation and presentation of performing arts by: developing and supporting Latino artists, providing educational opportunities for all people to experience Latino culture, and promoting cross-cultural dialogue. Productions are primarily presented in English.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "ThinkSelf Minnesota Deaf Adult Education & Advocacy",
            "Address": "2375 University Ave W, Suite 110",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55114",
            "County": "Ramsey",
            "Main phone number": "651-829-9089",
            "Fax Number": "651-493-3887",
            "Organization email": "hello@thinkself.org",
            "Organization website": "www.thinkself.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "thinkselfmn",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Aaron Gutzke",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "aaron@thinkself.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "Sara Hoggard",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "sarah@thinkself.org",
            "[contact_name_2]'s phone number": "651-243-4709",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Serves the Deaf and Hard of Hearing community. The Adult Education program provides the following classes: Citizenship, Basic Communication Skills (including ASL and English), Improving English reading/ writing, Math, Driver’s Education, and GED. The Advocacy program provides services to victims of domestic violence and sexual assault. All classes are in sign language.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Tutapona",
            "Address": "1935 County Rd W Suite 270",
            "City": "Roseville",
            "State": "MN",
            "Zip Code": "55113",
            "County": "Ramsey",
            "Main phone number": "651-755-5573",
            "Fax Number": "612-392-0400",
            "Organization email": "info@tutapona.com",
            "Organization website": "www.tutapona.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Tutapona",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Peggy Chun",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "Peggy@Tutapona.com",
            "[contact_name]'s phone number": "651-755-5573",
            "Second Contact name": "Carl Gaede",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "Carl@Tutapona.com",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Tutapona is expanding into the Twin Cites after providing trauma rehabilitation for refugees in Uganda and Iraq for the past ten years. We offer in-home diagnostic assessments and psychotherapy, and specialize in trauma rehabilitation therapy groups. We also provide supervision for social work graduates and offer workshops focusing on culturally competent therapy skills for work with refugees.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "WellShare International",
            "Address": "122 W. Franklin Ave. Suite 510",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55404",
            "County": "Hennepin",
            "Main phone number": "612-230-3252",
            "Fax Number": "",
            "Organization email": "info@wellshareinternational.org",
            "Organization website": "www.wellshareinternational.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "WellShare",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Michelle Heerey",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "mheerey@wellshareinternational.org",
            "[contact_name]'s phone number": "612-230-3250",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "We serve refugee and immigrant communities through public health education, outreach, training, research and partnerships through our responsive Community Health Worker model.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Amherst H. Wilder Foundation - Community Mental Health  and Wellness",
            "Address": "451 Lexington Pkwy. N.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "651-280-2310",
            "Fax Number": "651-280-2145",
            "Organization email": "",
            "Organization website": "www.wilder.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "wilderfoundation",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Bao Moua",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "bao.moua@wilder.org",
            "[contact_name]'s phone number": "651-280-2310",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,Refugee Resettlement Agency",
            "Please provide a description of services your organization offers": "Culturally specific,trauma informed mental health services for children, adult and families, and substance use disorder services for adults. Psychotherapy, psychological and diagnostic assessment, mental health case management, Assertive Community Treatment, substance use & social healing/adjustment services. Staff are bilingual & bicultural. Languages spoken Hmong, Karen, Cambodian & Vietnamese.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Southeast Asian Refugee Community Home (SEARCH)",
            "Address": "1113 E. Franklin Ave. Suite 212",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55404",
            "County": "Hennepin",
            "Main phone number": "612-673-9388",
            "Fax Number": "612-673-0840",
            "Organization email": "",
            "Organization website": "",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "SEARCH.MN.org",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Charles Benson",
            "[contact_name]'s position": "President",
            "[contact_name]'s email": "cbenson@search-mn.org",
            "[contact_name]'s phone number": "612-673-9388",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Employment and skills training services for refugee and low income individuals.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "East African Center",
            "Address": "2021 E. Hennepin Ave, 200",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55413",
            "County": "Hennepin",
            "Main phone number": "",
            "Fax Number": "",
            "Organization email": "hr@kulancenter.org",
            "Organization website": "http://www.kulancenter.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "https://twitter.com/EastAfricanCom3",
            "First Contact name": "Yasin Muse",
            "[contact_name]'s position": "Operations and Grant Directory",
            "[contact_name]'s email": "yasinnaqil@gmail.com",
            "[contact_name]'s phone number": "(651) 353-3153",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,Refugee Resettlement Agency,African (Immigrant)",
            "Please provide a description of services your organization offers": "We provide community wealth and wellness, coaching and job skills for youth at risk with substance use disorder, and family and child development",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "Community health, Social determinants of Health, Economic Development, Mental health, youth leadership development, refugee assistance, East African communities"
        },
        {
            "Name of Organization": "Options for Women East",
            "Address": "891 White Bear Ave N",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55106",
            "County": "Ramsey",
            "Main phone number": "(651) 776-2328",
            "Fax Number": "",
            "Organization email": "",
            "Organization website": "www.optionsforwomeneast.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": " https://www.facebook.com/optionsforwomeneast",
            "Instagram Page name": "",
            "Instagram Page Link": " @optionseast",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Jennifer Meyer",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "edjm@optionsforwomeneast.com",
            "[contact_name]'s phone number": "(651) 776-2328",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "We provide pregnancy tests, STI testing and treatment, limited ultrasounds, full prenatal care including delivery for uninsured patients, pregnancy and parenting eduation",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "pregnany tests, STI tests, limited ultrasouns, prenatal care"
        },
        {
            "Name of Organization": "Isuroon",
            "Address": "1600 E. Lake Street, 1",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55407",
            "County": "Hennepin",
            "Main phone number": "(612) 886-2731",
            "Fax Number": "",
            "Organization email": "",
            "Organization website": "www.isuroon.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Colnese Hendon",
            "[contact_name]'s position": "Development Directory",
            "[contact_name]'s email": "colnese.hendon@isuroon.org",
            "[contact_name]'s phone number": "(612) 834-1145",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "Isuroon's programs include home ownership/navigation, culturally-specific food shelf, youth development, mental health clinic, maternal/child health (Doula), civic engagement, leadership training, advocacy, and crisis management. ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "Somali, immigrant, refugee, women, food, housing, mental health, navigation, civic engagement, youth"
        },
        {
            "Name of Organization": "Transforming Generations",
            "Address": "550 Rice Street ",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55103",
            "County": "Ramsey",
            "Main phone number": "(651) 703-4172",
            "Fax Number": "",
            "Organization email": "info@transforminggenerations.org",
            "Organization website": "www.transforminggenerations.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "www.facebook.com/TransforminggenerationsMN",
            "Instagram Page name": " transforminggenerations",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Xay Yang",
            "[contact_name]'s position": "Queer Justice Director",
            "[contact_name]'s email": "xayy@transforminggenerations.org",
            "[contact_name]'s phone number": "(651) 703-4172",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,Asian and Pacific Islander",
            "Please provide a description of services your organization offers": "Transforming Generations provides direct service in the form of advocacy for victim/survivors of domestic violence/sexual violence, mental health therapy for families, children and individuals, especially centering Hmong/Southeast Asian population and LGBTQ+ folks. Transforming Generations also provides educational groups for Hmong men who have use abuse. In addition, we provide youth services in the forms of school-based advocacy, prevention programs such as Adventure Time and HeartBeats where youth talk about healthy relationships, teen dating violence and identity development. Transforming Generations also has a robust queer justice program that provides drop in support space, community engagement activities and leadership development opportunities. ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "Transforming Generations, TG, domestic violence, intimate partner violence, sexual assault, sexual violence, advocacy, order for protection, LGBTQ+, QTI, queer, trans, transgender, Hmong, Southeast Asian, Txiv Neej Yawg Program, perpetrator program, healthy relationships, mental health, therapy, sliding scale therapy, "
        },
        {
            "Name of Organization": "Korean American Association of Minnesota",
            "Address": "1331 County Road D Circle E",
            "City": "Vadnais Heights",
            "State": "MN",
            "Zip Code": "55109",
            "County": "Ramsey",
            "Main phone number": "(651) 440-9192",
            "Fax Number": "",
            "Organization email": "",
            "Organization website": "www.mnkorea.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "KAAM",
            "Facebook Page link": "",
            "Instagram Page name": "Kaam47th",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Eunah Oh",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "contact@mnkorea.org",
            "[contact_name]'s phone number": "(651) 440-9192",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Asian and Pacific Islander",
            "Please provide a description of services your organization offers": "Promote Korean identity to the next generation, build cooperative relationships with various Korean American organizations, strengthen the unity of Koean Americans in Minnesota, and establish a Korean cultural center for future generations",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "Korean, Korean Americans, Korean idendity, Korean heritage, K-culture, Korean generation, Korean community service, K-pop"
        },
        {
            "Name of Organization": "Sub-Saharan African Youth & Family Services in MN (SAYFSM)",
            "Address": "2395 University Ave. W, 200",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55114",
            "County": "Ramsey",
            "Main phone number": "(651) 644-3983",
            "Fax Number": "",
            "Organization email": "info@sayfsm.org",
            "Organization website": "www.sayfsm.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": " Ephraim Olani",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "egobbu@yahoo.com",
            "[contact_name]'s phone number": "(651) 644-3983",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "SAYFSM provides culturally and linguistically appropriate services to Africans. We provide case management, psychosocial and mental health group therapy for people living with HIV/AIDS, and other social services to the African communities in general.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "Medical case management, Psychosocial services, mental health services, community outreach services, women's sewing class training and more."
        },
        {
            "Name of Organization": "East African Healing Services",
            "Address": "8085 Wayzata Blvd Ste 100",
            "City": "Golden Valley",
            "State": "MN",
            "Zip Code": "55426",
            "County": "Hennepin",
            "Main phone number": "(651) 330-6048",
            "Fax Number": "",
            "Organization email": "info@eahsmn.org",
            "Organization website": "www.eahsmn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "https://www.linkedin.com/company/eahsmn/?viewAsMember=true",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Ibrahim Abumunye",
            "[contact_name]'s position": "Director",
            "[contact_name]'s email": "iabumunye@eahsmn.org",
            "[contact_name]'s phone number": "(651) 330-6048",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,Refugee Resettlement Agency,State Council,African (Immigrant),Asian and Pacific Islander,European,Latino/Latinx",
            "Please provide a description of services your organization offers": "Founded in 2012, EAHS provides professionally and culturally competent mental health rehabilitative services and other supportive services to refugees and immigrants who suffer impairment from symptoms caused by trauma and mental illness. EAHS services respect the culture, religion, and language of clients. Certified by MN Department of Human Services as an Adult Rehabilitative Mental Health Services (ARMHS) provider, we currently work with clients in Ramsey, Dakota, Hennepin, Anoka and Washington counties.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "Mental Health Clinic, Trauma, social worker, therapist, cultural, Housing support, children services "
        },
        {
            "Name of Organization": "US-China Peoples Friendship Association - Minnesota Chapter",
            "Address": "P.O. Box 19464 ",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55419",
            "County": "Hennepin",
            "Main phone number": "(612) 396-0979",
            "Fax Number": "",
            "Organization email": "uscpfa_mn@hotmail.com",
            "Organization website": "https://uscpfa-mn.org/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "https://www.facebook.com/search/top?q=us-china%20peoples%20friendship%20association%20-%20minnesota%20chapter",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Ralph Beha",
            "[contact_name]'s position": "President",
            "[contact_name]'s email": "uscpfa_mn@hotmail.com",
            "[contact_name]'s phone number": "(612) 396-0979",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,Asian and Pacific Islander",
            "Please provide a description of services your organization offers": "US-China Peoples Friendship Association - Minnesota Chapter (USCPFA-MN) is dedicated to developing and strengthening friendship and mutual understanding between the peoples of the United States and China. Founded in 1974, the Minnesota Chapter of USCPFA is a non-profit, tax-exempt, 501c(3) non-partisan, educational organization. Our members come from all backgrounds and interests. However, we share a common goal of promoting friendship between our two countries through individual person-to-person connections.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "China, Education, Cultural Exchange, US-China Relations, Mutual Understanding, Community, Non-profit"
        },
        {
            "Name of Organization": "AccessAbility, Inc.",
            "Address": "360 Hoover St. N.E. ",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55413",
            "County": "Hennepin",
            "Main phone number": "(612) 331-5958",
            "Fax Number": "612-331-2448",
            "Organization email": "",
            "Organization website": "www.accessability.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Jacki Gale ",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "Jgale@accessability.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "Linda Cazett",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": " lcazett@accessability.org",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "A not-for-profit diversified training, employment & production facility providing training, work & recreational opportunities for individuals with disabilities & economic disadvantages who have barriers to",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Black Storytellers Alliance",
            "Address": "1112 Newton Ave. N. ",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55411",
            "County": "Hennepin",
            "Main phone number": "(612) 529-5864",
            "Fax Number": "612-529-5951",
            "Organization email": "nzulu@blackstorytellers.com",
            "Organization website": "www.blackstorytellers.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "https://www.facebook.com/Black-Storytellers-Alliance-134570813221307/",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Nothando Zulu",
            "[contact_name]'s position": "Director",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Promoting and preserving the art of storytelling. Specializes in storytelling performances for schools, libraries, community centers, and corporations, and conducts large and small group",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Blue Earth County Employment Services / MCRI Worksource",
            "Address": "421 E. Hickory St. Suite 400 ",
            "City": "Mankato",
            "State": "MN",
            "Zip Code": "56001",
            "County": "Blue Earth",
            "Main phone number": "(507) 386-5750",
            "Fax Number": "507-386-5788",
            "Organization email": "mhighum@mrciworksource.org",
            "Organization website": "www.mrciworksource.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Marcia Highum",
            "[contact_name]'s position": "",
            "[contact_name]'s email": " MHighum@BECES.org",
            "[contact_name]'s phone number": "(507) 386-5751",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Provides employment plan development, job coaching, work skill instruction,  ABE, and coordination of MFIP support services. MRCI Refugee Services works with refugees to help them achieve long- term stability, become self-sufficient, and contributing members of the communities in which they live. They work with families to facilitate economic independence and social adjustment to allow for successful integration into the community. Provides refugee resettlement services, assists  with referral to access available services, employment services, and social services. Employment services offered in Anuak, Arabic, Nuer, Somali, and Spanish.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Commonbond Community",
            "Address": "1080 Montreal Ave. St. Paul, MN 55116",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55116",
            "County": "Ramsey",
            "Main phone number": "(651) 291-1750",
            "Fax Number": "651-291-1003",
            "Organization email": "info@commonbond.org",
            "Organization website": "www.commonbond.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "CommonBondCommunities",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Michelle Basham ",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "michelle.basham@commonbond.org ",
            "[contact_name]'s phone number": "(651) 290-6243",
            "Second Contact name": "Elizabeth Hagstrom",
            "[contact_name_2]'s position": "elizabeth.hagstrom@commonbond.org ",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "651-290-6239",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "A nonprofit provider of affordable housing for seniors, families and people with disabilities offering social services for residents. For housing information please call the main number listed only.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "ECHO Minnesota (Emergency, Community, and Health Outreach) \"",
            "Address": "172 E. Fourth St. St. Paul, MN 55101",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55101",
            "County": "Ramsey",
            "Main phone number": "(651) 229-1304",
            "Fax Number": "",
            "Organization email": "info@echominnesota.org",
            "Organization website": "www.echominnesota.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "echominnesota",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Lillian McDonald ",
            "[contact_name]'s position": "Executive Director ",
            "[contact_name]'s email": "mcdonald@echominnesota.org",
            "[contact_name]'s phone number": "(651) 789-4342",
            "Second Contact name": "Efrén Maldonado ",
            "[contact_name_2]'s position": "Community Outreach & Program Coordinator",
            "[contact_name_2]'s email": "maldonado@echominnesota.org",
            "[contact_name_2]'s phone number": "651-789-4326",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "ECHO provides high-quality health, safety and emergency preparedness educational materials in multiple languages via TV, phone, radio, Web, and email. These communication tools function as an emergency infrastructure ensuring that in a crisis, ECHO can rapidly and effectively translate, produce and distribute life saving health and safety messages.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "The Family Partnership",
            "Address": "414 S Eighth St. Minneapolis, MN 55404",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55404",
            "County": "Hennepin",
            "Main phone number": "(612) 339-9101",
            "Fax Number": "612-339-9150",
            "Organization email": "info@thefamilypartnership.org",
            "Organization website": "www.thefamilypartnership.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "TheFamilyPartnership",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "John Till",
            "[contact_name]'s position": "Senior Vice President of Program Strategy and Innovation",
            "[contact_name]'s email": "jtill@thefamilypartnership.org",
            "[contact_name]'s phone number": "(612) 728-2086",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "\"The Family Partnership is a multiservice nonprofit organization with a 137-year-old legacy of service to children and families in the Twin Cities in need of support.  Our mission is building strong families, vital communities, and better futures for children. Through counseling, education, and advocacy programs, we are closing opportunity and achievement gaps for those living in poverty and providing them with the skills and resources to reach their full potential. (Somali, Native American, Hmong, or Spanish)\"  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Immigrant Law Center of Minnesota",
            "Address": "1401 Gardena Ave. N.E. ",
            "City": "Fridley",
            "State": "MN",
            "Zip Code": "55432",
            "County": "Anoka",
            "Main phone number": "(763) 571-5604",
            "Fax Number": "763-273-8487",
            "Organization email": "icm@islamiccentermn.org",
            "Organization website": "www.islamiccentermn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Islamic-Center-of-Minnesota",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Br. Faisal Mian",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "Admin@islamiccentermn.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "Dr S Khan",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "president@islamiccentermn.org ",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "The Islamic Center of Minnesota operates a free clinic and food-shelf open to all in addition to adult education services, a library/bookstore, burial services and family counseling. The ICM also has a Mosque in Columbia Heights.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Intercultural Mutual Assistance Association",
            "Address": "2500 Valleyhigh Dr. N.W.",
            "City": "Rochester",
            "State": "MN",
            "Zip Code": "55901",
            "County": "Olmsted",
            "Main phone number": "(507) 289-5960",
            "Fax Number": "507-289-6199",
            "Organization email": "",
            "Organization website": "www.imaa.net ",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "IMAA-1505009729788951",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Ron Buzard",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "ron.buzard@imaa.net",
            "[contact_name]'s phone number": "",
            "Second Contact name": "Ponloeu Chim",
            "[contact_name_2]'s position": "Associate Director",
            "[contact_name_2]'s email": "ponloeu.chim@imaa.net",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "IMAA has four program areas: employment services, health care access & education   services, professional language services,   and social services. The refugee health   program area includes a Community Health Worker program. ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Mankato Area Adult Basic Education",
            "Address": "110 Fulton St. Room 255",
            "City": "Mankato",
            "State": "MN",
            "Zip Code": "56001",
            "County": "Blue Earth",
            "Main phone number": "(507) 345-5222",
            "Fax Number": "507-387-6716",
            "Organization email": "abe@isd77.k12.mn.us",
            "Organization website": "www.mankatocer.com ",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Jennifer Gibson",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "ESL, GED, adult diploma, family literacy, employment skills, college prep, computer literacy.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Masjid An-Nur (mosque)",
            "Address": "1729 Lyndale Ave. N. P.O. Box 11781 ",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55411",
            "County": "Hennepin",
            "Main phone number": "(612) 521-1749",
            "Fax Number": "612-521-1282",
            "Organization email": "info@masjidannur.org",
            "Organization website": "www.masjidannur.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "Masid-An-Nur-Minneapolis- MN-141338360182\"",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Imam Makram El-Amin",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "imamelamin@masjidannur.org ",
            "[contact_name]'s phone number": "(612) 521-5990",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "The Mosque is open for daily prayers and Islamic religious studies. Also operates an adult day center and offers many classes.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Minnesota Food Association",
            "Address": "14220-B Ostlund Trail N. ",
            "City": "Marine on St. Croix",
            "State": "MN",
            "Zip Code": "55407",
            "County": "Hennepin",
            "Main phone number": "(651) 433-3676",
            "Fax Number": "651-433-5050",
            "Organization email": "info@mnfoodassociation.org",
            "Organization website": "www.mnfoodassociation.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "mnfoodassociation",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Hillary Otey Wold",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "hillary@mnfoodassociation.org ",
            "[contact_name]'s phone number": "(651) 433-3676",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "The mission of Minnesota Food Association (MFA) is to build a sustainable food  system based on social, economic, and environmental justice through education, training and partnerships.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Neighborhood House",
            "Address": "179 E. Robie St.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55107",
            "County": "Ramsey",
            "Main phone number": "(651) 789-2500",
            "Fax Number": "651-789-2501",
            "Organization email": "",
            "Organization website": "www.neighb.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "neighborhoodhouseMN",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Joan Schlecht",
            "[contact_name]'s position": "Director of Programs",
            "[contact_name]'s email": "jschlect@neighb.org ",
            "[contact_name]'s phone number": "(651) 789-2531",
            "Second Contact name": "Bwei Paw ",
            "[contact_name_2]'s position": "Resettlement Staff",
            "[contact_name_2]'s email": "bpaw@neighb.org ",
            "[contact_name_2]'s phone number": "651-789-2544",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Helping refugees improve their quality of life through access to information on  employment, life skills, education, housing, and parenting. Participants are also connected to other Neighborhood House programs, including food support, youth leadership, and English classes. Refugee resettlement family support is provided for Karen and Somali.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "New Americans Alliance for Development (NAAD)",
            "Address": " 1821 University Ave. W, Suite S328",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "(651) 645-5828",
            "Fax Number": "",
            "Organization email": "naad.mn@gmail.com",
            "Organization website": "https://newamericansalliance.org/ ",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "NAADorg",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Mimi Oo",
            "[contact_name]'s position": "Program Coordinator",
            "[contact_name]'s email": "aafacd-inc@hotmail.com",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "NAAD's main focus is on their Foreign Trained Health Professionals (FTHP) program. This program strives to promote economic self- sufficiency and advancement of immigrants who are foreign trained healthcare professionals in Minnesota. NAAD ensures that they get support to prepare and pass  the licensure exams and practice in their healthcare profession in the United States.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Sabathani Community Center",
            "Address": "310 E. 38th St.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55409",
            "County": "Hennepin",
            "Main phone number": "(612) 821-2300",
            "Fax Number": "612-823-7998",
            "Organization email": "",
            "Organization website": "www.sabathani.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "SabathaniMpls",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Cindy Booker",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": " cbooker@sabathani.org  ",
            "[contact_name]'s phone number": "(612) 252-2409",
            "Second Contact name": "Pat Anderson",
            "[contact_name_2]'s position": "EHDI Coordinator",
            "[contact_name_2]'s email": "panderson@sabathani.org",
            "[contact_name_2]'s phone number": "612-821-2315",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Services available to aid in job readiness, basic needs, education & school success, mental health care, child care, navigation, emergency assistance, and after-school programming for children and youth. There  is a food shelf on-site along with free clothing and household goods, free health care and low-cost dental for children, senior services, family services and cultural services.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "South Minneapolis Workforce Center",
            "Address": "777 E. Lake St.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55407",
            "County": "Hennepin",
            "Main phone number": "(612) 821-4000",
            "Fax Number": "612-821-4014",
            "Organization email": "careerforce.minneapolissouth@state.mn.us",
            "Organization website": "https://www.careerforcemn.com/minneapolissouth",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Specialty services include non-English job placement, application, resume preparation, interviewing practices, preparation for the American world of work,  transportation to submit job applications, interviews, bus-routes training, and job coaching after placement. Most services are free of charge.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "St Cloud Area Services",
            "Address": "830 W St Germain St. Suite 300",
            "City": "St. Cloud",
            "State": "MN",
            "Zip Code": "56301",
            "County": "Stearns",
            "Main phone number": "(320) 253-0121",
            "Fax Number": "320-253-5794",
            "Organization email": "",
            "Organization website": " www.mylegalaid.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Ann Cofell",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "acofell@mylegalaid.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Provides free civil legal services to people with low incomes in central Minnesota. Services range from educating clients about their rights to advocating on their  behalf and representing clients in court. Legal issues include housing, family law, consumer issues, taxes, immigration and more. Languages: Somali, Spanish, Swahili.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "United Way of Freeborn County",
            "Address": "341 S. Broadway",
            "City": "Albert Lea",
            "State": "MN",
            "Zip Code": "56007",
            "County": "Freeborn",
            "Main phone number": "(507) 373-8670",
            "Fax Number": "507-377-0851",
            "Organization email": "director@unitedwayfc.org",
            "Organization website": "http://www.unitedwayfc.org/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "United-Way-of-Freeborn-County",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Ann Austin",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "United Way of Freeborn County is focused on the areas of education, income and health.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Council on Asian-Pacific Minnesotans",
            "Address": "658 Cedar St. Ste 160",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55155",
            "County": "Ramsey",
            "Main phone number": "(651) 757-1740",
            "Fax Number": "651-297-8735",
            "Organization email": "capm@state.mn.us",
            "Organization website": "http://mn.gov/capm/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Council-on-Asian-Pacific- Minnesotans",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Sia Her",
            "[contact_name]'s position": " Executive Director",
            "[contact_name]'s email": "sia.her@state.mn.us ",
            "[contact_name]'s phone number": "(651) 757-1741",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Advises the governor and members of the legislature on issues pertaining to Asian Pacific Minnesotans. Advocates on issues of importance to the Asian Pacific community and acts as a broker between the Asian Pacific community and mainstream society.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "African Assistance Program",
            "Address": "6040 Earle Brown Dr. Ste 200",
            "City": "Brooklyn Center",
            "State": "MN",
            "Zip Code": "55430",
            "County": "Hennepin",
            "Main phone number": "(763) 560-9643",
            "Fax Number": "763-560-9720",
            "Organization email": "info@aapusa.org",
            "Organization website": "www.aapusa.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "John P. Tarley",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": " jtarley@aapusa.org ",
            "[contact_name]'s phone number": "(763) 560-8995",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "Provides services that focus on employment, health education, and community empowerment.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "African Community Services",
            "Address": "1305 E. 24th St.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55404",
            "County": "Hennepin",
            "Main phone number": "(612) 721-9984",
            "Fax Number": "612-721-9031",
            "Organization email": "homar@africancs.org",
            "Organization website": "www.africancs.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Abdillahi Nur",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "anur@africancs.org  ",
            "[contact_name]'s phone number": "",
            "Second Contact name": "Khalif Jama",
            "[contact_name_2]'s position": "Program Manager",
            "[contact_name_2]'s email": " jtarley@aapusa.org ",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "Serves all immigrants and refugees coming from all over the world, particularly those coming from Africa. We help them with employment, housing, and many other services. Several languages are spoken.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "African Development Center",
            "Address": "1931 S. Fifth St.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55454",
            "County": "Hennepin",
            "Main phone number": "(612) 333-4772",
            "Fax Number": "612-746-0470",
            "Organization email": "info@adcminnesota.org",
            "Organization website": "www.adcminnesota.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "adcminnesota",
            "Facebook Page link": "Nasibu Sareva",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Nasibu Sareva",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "nsareva@adcminnesota.org",
            "[contact_name]'s phone number": "(612) 877-8263",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "Provides services that involve business development and financial literacy.  Through workshops and consultations on financial literacy, business development, and home ownership, ADC provides culturally competent services to Minnesota's African community.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "African Immigrant Services",
            "Address": "8401 73rd Ave. N., Suite E8",
            "City": "Brooklyn Park",
            "State": "MN",
            "Zip Code": "55428",
            "County": "Hennepin",
            "Main phone number": "(763) 208-6635",
            "Fax Number": "763-432-6700",
            "Organization email": "info@aisusa.org",
            "Organization website": "www.aisfotl.org/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "aisusa",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Abdullah Kiatamba",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "akiatamba@aisusa.org ",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "African immigrants and refugees face many barriers as they navigate into mainstream communities. AIS exists to confront  these challenges through increased civic engagement, where African immigrants strive to create inclusive communities as change agents, and work to build bonds across cultures as volunteers serving  others; and through creative access to resources, to help close the information gap (which increases access to opportunities), empowering them to achieve economic independence. Services include: civic engagement initiatives, community engagement & education, computer learning center, immigration sessions & clinic, and Minnesota Health Care Program.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "African Immigrant Community Services",
            "Address": " 1933 13th Ave. S.",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55404",
            "County": "Hennepin",
            "Main phone number": "(612) 871-9184",
            "Fax Number": "612-871-9162",
            "Organization email": "aicsmn@gmail.com",
            "Organization website": "www.aicsmn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Mustafa Hassan",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "(612) 309-2097",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "Provides basic adult literacy programs, youth programs, housing assistance, employment and services, legal assistance, and school readiness. Serves East Africans and Kiswahili speakers, Somali, Amharic, and Oromo.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Al-Amal School",
            "Address": "1401 Gardena Ave. N.E",
            "City": "Fridley",
            "State": "MN",
            "Zip Code": "55432",
            "County": "Anoka",
            "Main phone number": "(763) 571-8886",
            "Fax Number": "763-571-1925",
            "Organization email": "info@al-amal.org",
            "Organization website": "www.al-amal.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Audrey Zahra Williams ",
            "[contact_name]'s position": "Principal",
            "[contact_name]'s email": " zahra.williams@al-amal.org ",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Full-time Islamic school in Minnesota with Pre-K through 12th grade offered.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "CANA-Center for Africans Now in America, Inc.",
            "Address": "6000 Bass Lake Rd. Ste 206",
            "City": "Crystal",
            "State": "MN",
            "Zip Code": "55429",
            "County": "Hennepin",
            "Main phone number": "(763) 533-4986",
            "Fax Number": "952-707-9684",
            "Organization email": "support@mncana.com",
            "Organization website": "www.mncana.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "CANA-Center-For-Africans-Now-In- America-Inc-1529871563907320",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Dr. Kate Onyeneho",
            "[contact_name]'s position": " President / CEO",
            "[contact_name]'s email": "zkateonyeneho@yahoo.com",
            "[contact_name]'s phone number": "(952) 484-6796",
            "Second Contact name": "Dr. Sylvester Onyeneho ",
            "[contact_name_2]'s position": "Food Safety and Security Consultant",
            "[contact_name_2]'s email": "sony918@yahoo.com ",
            "[contact_name_2]'s phone number": " 952-484-6796",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "CANA- Center for Africans Now in America, Inc. was created as a means to provide education, health care, social services, training and employment in preparation for people to use as a pathway out of poverty. It was also created to empower Racial Ethnic African Descent (READ) communities to preserve their language and culture. Programs utilize African Multicultural and Multilingual services.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "CANA-Center for Africans Now in America, Inc.",
            "Address": "900 W. 128th St., Suite 101",
            "City": "Burnsville",
            "State": "MN",
            "Zip Code": "55337",
            "County": "Dakota",
            "Main phone number": "(952) 736-7925",
            "Fax Number": "952-707-9684",
            "Organization email": "support@mncana.com",
            "Organization website": "www.mncana.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "CANA-Center-For-Africans-Now-In- America-Inc-1529871563907320",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Dr. Kate Onyeneho",
            "[contact_name]'s position": "President/ CEO",
            "[contact_name]'s email": "zkateonyeneho@yahoo.com",
            "[contact_name]'s phone number": "(952) 484-6796",
            "Second Contact name": "Dr. Sylvester Onyeneho",
            "[contact_name_2]'s position": "Food Safety and Security Consultant",
            "[contact_name_2]'s email": "sony918@yahoo.com",
            "[contact_name_2]'s phone number": " 952-484-6796",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "CANA- Center for Africans Now in America, Inc. was created as a means to provide education, health care, social services, training and employment in preparation for people to use as a pathway out of poverty. It was also created to empower Racial Ethnic African Descent (READ) communities to preserve their language and culture. Programs utilize African Multicultural and Multilingual services.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Coalition of African Community Services of Kandiyohi County - African Development Center",
            "Address": "333 6th ST SW Ste 2",
            "City": "Willmar",
            "State": "MN",
            "Zip Code": "56201",
            "County": "Kandiyohi",
            "Main phone number": "(320) 262-8545",
            "Fax Number": "",
            "Organization email": "",
            "Organization website": "http://www.adcminnesota.org/ community-impact/profiles/partner/coalition- african-community-services",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Abdi Duh ",
            "[contact_name]'s position": "Founder",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "(320) 223-3510",
            "Second Contact name": "Abdirahin Hussen ",
            "[contact_name_2]'s position": "Regional Manager, Central Minnesota",
            "[contact_name_2]'s email": "ahussen@adcminnesota.org",
            "[contact_name_2]'s phone number": "320-262-8546",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "Based in Willmar, the Coalition of African Community Services of Kandiyohi County helps African immigrants become well adjusted to life in the United States  while focusing on bridging African and American cultures so that all Willmar citizens understand and appreciate one another. The coalition is supported by  three staff members and provides services and assistance with housing processes and community formation to Africans in the Willmar area. These services can be provided in both English and Somali",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Disabled Immigrant Association",
            "Address": "3033 Second Ave. S. ",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55408",
            "County": "Hennepin",
            "Main phone number": "(612) 824-7075",
            "Fax Number": "612-822-2446",
            "Organization email": "info@dialink.org",
            "Organization website": "http://www.dialink.org/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Mahad Abdi",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "mahad@dialink.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "Serves immigrant persons with disabilities living in the Twin Cities with  information, referrals, education regarding rights, peer support, and guidance. Staff provides translation services and assist clients in filling out applications for education and healthcare. Languages spoken: Somali.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "East Africa Health",
            "Address": "1349 Maryland Ave.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55106",
            "County": "Ramsey",
            "Main phone number": "(612) 306-0539",
            "Fax Number": "",
            "Organization email": "osmanahmed@eahpro.org",
            "Organization website": "www.eahpro.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Dr. Osman Ahmed (Harare)",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "osman@eahpro.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "A nonprofit organization dedicated to improving the health and wellness of the East African community in the USA. East Africa Health Project serves those from east Africa: Somalia, Kenya, Ethiopia/ Oromo, and Djibouti.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Eritrean Community Center",
            "Address": "1935 University Ave. W",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "(763) 746-6786",
            "Fax Number": "",
            "Organization email": "",
            "Organization website": "",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": " https://www.facebook. com/pages/Eritren-Community- Center/168150853197782",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Dawit Solomon ",
            "[contact_name]'s position": "Chairman",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "(763) 746-6786",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "Provides health, social, and educational services while retaining the Eritrean cultural traditions in a familiar environment.  Services include: information on housing and food resources, interpreting services,  cultural events and youth programs.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Ethiopian Community in Minnesota",
            "Address": "265 Oneida St. Suite 209 ",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55102",
            "County": "Ramsey",
            "Main phone number": "(651) 645-9668",
            "Fax Number": "",
            "Organization email": "info@ethiomn.org",
            "Organization website": "www.ethiomn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Ms. Lemlem Kebede",
            "[contact_name]'s position": "President",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "African (Immigrant)",
            "Please provide a description of services your organization offers": "Provides information and resources related to education, health care, housing and employment. Shares skills and knowledge for the benefit and welfare of the Ethiopian community, and preserves the artistic culture of Ethiopians.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Ka Joog Organization",
            "Address": " 1420 Washington Ave. S ",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55454",
            "County": "Hennepin",
            "Main phone number": "(612) 255-3524",
            "Fax Number": "612-255-3523",
            "Organization email": "info@kajoog.org",
            "Organization website": " www.kajoog.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": " kajoog.org ",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Mohamed Farah ",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "mfarah@kajoog.org  ",
            "[contact_name]'s phone number": "(651) 795-1589",
            "Second Contact name": "Daud Mohamed",
            "[contact_name_2]'s position": " Community Outreach",
            "[contact_name_2]'s email": "daud.mohamed@kajoog.org",
            "[contact_name_2]'s phone number": "612-404-4285",
            "Please select what communities or groups you serve": "African (Immigrant)",
            "Please provide a description of services your organization offers": "Ka Joog is the leading Somali nonprofit organization tailored towards enriching the lives of Somali American youth by  utilizing the positive elements of education, mentoring, employment, and the arts.  Ka Joog's mission is to motivate youth to pursue higher education, while promoting and building community ties at events throughout Minnesota. Ka Joog helps Somali teens make the right choices, and provides positive outlets for their feelings and experiences through the arts-music, poetry, visual arts, drama, and other media.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Minnesota African Women's Association",
            "Address": "3300 County Rd. 10, Suite 510 ",
            "City": "Brooklyn Center",
            "State": "MN",
            "Zip Code": "55429",
            "County": "Hennepin",
            "Main phone number": "(763) 561-0405",
            "Fax Number": "",
            "Organization email": "mawa0302@yahoo.com",
            "Organization website": " www.mawanet.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "mawawomen",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Ms. Nyango Melissa Nambangi ",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "LaBelle Makane",
            "[contact_name_2]'s email": " Girls Leadership and AGILE Program Coordinator",
            "[contact_name_2]'s phone number": "mawaagile@yahoo.com",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "Promotes the health and well-being of African women and their families in the Twin Cities through research, education, advocacy and programming.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Organizations of Liberians in MN",
            "Address": "7001 78th Ave. N. Suite 200",
            "City": "Brooklyn Park",
            "State": "MN",
            "Zip Code": "55445",
            "County": "Hennepin",
            "Main phone number": "(763) 270-5894",
            "Fax Number": "",
            "Organization email": "olmnus1@gmail.com",
            "Organization website": "https://olmn.org/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "Organization-of-Liberians-in-Minnesota-OLM-718764771585492",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Lyee Kamaty Diahn",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "olmnus1@gmail.com",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "African (Immigrant)",
            "Please provide a description of services your organization offers": "Provides adjustment social services and intermediation for Liberians and other immigrants.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Oromo Community Minnesota",
            "Address": "465 Mackubin St.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55103",
            "County": "Ramsey",
            "Main phone number": "(651) 440-9043",
            "Fax Number": "",
            "Organization email": "info@oromomn.org",
            "Organization website": "www.oromomn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "OromoCommunityMN",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "Provides a multitude of social services, staff speaks Oromo. Services include health education, health access, employment counselling, and youth enrichment. ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Oromo Studies Association",
            "Address": "P.O. Box 6541 ",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55406",
            "County": "Hennepin",
            "Main phone number": "(651) 776-5839",
            "Fax Number": "",
            "Organization email": "",
            "Organization website": " www.oromostudies.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "OromoStudiesAssociation",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Yeshi Tolessa ",
            "[contact_name]'s position": "Treasurer",
            "[contact_name]'s email": "lemu0003@umn.edu ",
            "[contact_name]'s phone number": "(651) 776-5839",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "The Oromo Studies Association (OSA) is a scholarly, multi-disciplinary, nonprofit organization, established by Oromo and non-Oromo scholars to promote studies on people. OSA is an international academic and relevant to the Oromo organization committed to the study and documentation of Oromo history and culture. It was established by scholars who were concerned about the lack of adequate knowledge about the Oromo people.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Pan African Network",
            "Address": "St. Alphonsus Church 7025 Halifax Ave. N.",
            "City": "Brooklyn Center",
            "State": "MN",
            "Zip Code": "55429",
            "County": "Hennepin",
            "Main phone number": "(763) 560-3251",
            "Fax Number": "763-560-0336",
            "Organization email": "parishoffice@stalsmn.org",
            "Organization website": "https://www.stalsmn.org/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Cecil Camara",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "(763) 560-3251",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "The Pan African Network focuses on issues in education and trends, which affect students and professionals of color.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Rural Health Care Initiative",
            "Address": "P.O. Box 14822",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55414",
            "County": "Hennepin",
            "Main phone number": "(651) 503-1369",
            "Fax Number": "",
            "Organization email": "Maggiepilac@gmail.com",
            "Organization website": "www.rhcimnsl.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Rural Healthcare Initiative",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Maggie Pilacinski",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "Maggiepilac@gmail.com",
            "[contact_name]'s phone number": "(651) 808-3807",
            "Second Contact name": "Carol Nelson",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "cnelson@rhcimnsl.org",
            "[contact_name_2]'s phone number": "6515031369",
            "Please select what communities or groups you serve": "African (Immigrant)",
            "Please provide a description of services your organization offers": "Resource and partner with rural Sierra Leone communities as they work to rebuild and advance their rural health care systems.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Somali American Parent Association",
            "Address": "African Development Center Business Annex 1929 S. Fifth St., Suite 101",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55454",
            "County": "Hennepin",
            "Main phone number": "(612) 359-4949",
            "Fax Number": "612-359-4994",
            "Organization email": "aali@mnsapa.org",
            "Organization website": "http://mnsapa.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "momoh@mnsapa.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": " A. Bulale",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "abulale@mnsapa.org",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "African (Immigrant)",
            "Please provide a description of services your organization offers": "SAPA empowers East African parents to support their children's schoolwork by partnering with community institutions, charter schools, and school districts. SAPA believes that advocating for and supporting East African students and their families as they strive towards academic excellence and creating stronger connections between the East African community and the education system will lead to a stronger, better educated community. SAPA has programs for students, parents, schools, and the community.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Umunne Cultural Association",
            "Address": "P.O. Box 4736 ",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "(651) 644-2010",
            "Fax Number": "",
            "Organization email": "generalsecretary@umunne.org",
            "Organization website": "www.umunne.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "Umunne",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Chuma Dike ",
            "[contact_name]'s position": "President",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "African (Immigrant)",
            "Please provide a description of services your organization offers": "Their purpose is to enhance the cultural, educational, civic, and general wellbeing of their members as well as educate members of the community about Igbo culture and traditions, and to involve their members in community development and charitable causes. They also coordinate cultural events, such as Igbofest.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Asian Ministries c/o Union Gospel Mission",
            "Address": "\"800 Minnehaha Ave E, Suite 250 ",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55106",
            "County": "Ramsey",
            "Main phone number": "(651) 444-5808",
            "Fax Number": "",
            "Organization email": "info@hamaainc.org",
            "Organization website": "https://ccda.org/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Pa Thao Yang",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "pyang@ugmtc.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,Asian and Pacific Islander",
            "Please provide a description of services your organization offers": "Offering tutoring, mentoring, Bible Studies and youth groups for elementary, junior and senior high school students, Union Gospel Mission  is continuing its long tradition of extending a helping hand to those looking for a new home. And in the process, we hope our new friends will also find a new life in God.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Chinese Social Service Center",
            "Address": "6632 Penn Ave. S.",
            "City": "Richfield",
            "State": "MN",
            "Zip Code": "55423",
            "County": "Hennepin",
            "Main phone number": "(612) 529-2602",
            "Fax Number": "612-465-2733",
            "Organization email": "",
            "Organization website": "www.csscmn.info",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "https://www.facebook.com/casscenter/",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Yi Li You ",
            "[contact_name]'s position": "Director",
            "[contact_name]'s email": "yiliyou@msn.com",
            "[contact_name]'s phone number": "(952) 200-8972",
            "Second Contact name": "Qianting Xu",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "darvonnytril@msn.com",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "African (Immigrant)",
            "Please provide a description of services your organization offers": "Provides social services to Chinese immigrants and refugees. Programs include ESL and citizenship classes; Monthly Senior Program: seniors who have no insurance gather together for socialization, listen  to health seminar, and engage in creative activities; after-school and summer youth programs for K-12 school children who  are behind academically; health screening and education program to help uninsured,  low income clients to do health screenings through SAGE program and others; home care services to the elderly and disabled;  and provides senior adult day care services.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Karen Organization of Minnesota (KOM)",
            "Address": "2353 Rice St., Suite 240",
            "City": "Roseville",
            "State": "MN",
            "Zip Code": "55113",
            "County": "Ramsey",
            "Main phone number": "(651) 788-7593",
            "Fax Number": "651-788-7909",
            "Organization email": "info@mnkaren.org",
            "Organization website": "www.mnkaren.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "mnkarenorg",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Lisa Khang",
            "[contact_name]'s position": "Training Coordinator",
            "[contact_name]'s email": "lkhang@mnkaren.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "Alexis Walstad ",
            "[contact_name_2]'s position": "Co-Executive Director",
            "[contact_name_2]'s email": "awalstad@mnkaren.org",
            "[contact_name_2]'s phone number": " 651-202-3120",
            "Please select what communities or groups you serve": "Asian and Pacific Islander",
            "Please provide a description of services your organization offers": "A full service community based organization assisting the Karen and other refugees from Burma. Offering employment and social services including public assistance, housing, immigration, school/ELL enrollment, MNsure assistance, and health and life skills trainings. Also offering youth academic and leadership development for grades 6-12 in SPPS. Pre- scheduled appointments recommended, but walk-in hours available M-F 8:30am-5:00pm.  Languages: English, Sgaw Karen, Pwo Karen, Burmese, Thai.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Lao Advancement Organization of America",
            "Address": "2648 W. Broadway Ave. ",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55411",
            "County": "Hennepin",
            "Main phone number": "(612) 302-9154",
            "Fax Number": "612-522-2431",
            "Organization email": "info@laoamerica.org",
            "Organization website": "www.laoamerica.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Khamchanh Phanthavong, PhD ",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "khphanthavong@laoamerica.org",
            "[contact_name]'s phone number": "(612) 767-1684",
            "Second Contact name": "Bounleuth Gowing ",
            "[contact_name_2]'s position": "Program Director",
            "[contact_name_2]'s email": " bgowing@laoamerica.org",
            "[contact_name_2]'s phone number": "612-767-1684",
            "Please select what communities or groups you serve": "Asian and Pacific Islander",
            "Please provide a description of services your organization offers": "The Lao Advancement Organization of America (LAOA) builds upon the strengths and traditions of Lao culture to give Lao families the tools they need to succeed in their new homeland. Youth programs and services: Lao traditional dance program, chemical dependency prevention programs (Youth For Change), and leadership training. Elderly health and social services programs: special access program, nutrition and congregate meals program, assisted transportation program, Lao seniors quality of life program (including: elders day care and elders respite care).  We serve Lao and Hmong populations in the Twin Cities and seven other counties in Minnesota. Languages: Lao, English, Thai.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Lao Assistance Center of Minnesota",
            "Address": "503 Irving Ave. N. Suite 100A ",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55405",
            "County": "Hennepin",
            "Main phone number": "(612) 374-4967",
            "Fax Number": "612-312-1150",
            "Organization email": "phouninh@laocenter.org",
            "Organization website": "www.laocenter.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": " The-Lao-Assistance-Center-Of- Minnesota-142426149136663",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Sunny Chanthanouvong",
            "[contact_name]'s position": " Executive Director ",
            "[contact_name]'s email": " sunny@laocenter.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "Chongchith Saengsudham",
            "[contact_name_2]'s position": " Program Manager, Health Services",
            "[contact_name_2]'s email": "chongchith@laocenter.org",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Asian and Pacific Islander",
            "Please provide a description of services your organization offers": "Serves as a resource for Lao community providing information about local clinics and health-related agencies that specialize in serving Lao. Resource for those looking for legal referral, tax preparation, elderly health care access, elderly special access, chemical dependency, court probation community works, health insurance, cervical cancer screening, Hep. B screening, breast cancer education, civic Engagement, arts, traditional dance, classical folk, unemployment, organizing, US citizenship class, translation, interpretation, alcohol treatment, complete alcohol assessments, domestic abuse referral, financial literacy, voting, housing including house foreclosure, house rental and housing education pre-purchase and post-purchase. Languages: English, Lao, or Thai.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "St. Paul Hmong Alliance Church",
            "Address": "1770 McMenemy St.",
            "City": "Maplewood",
            "State": "MN",
            "Zip Code": "55117",
            "County": "Ramsey",
            "Main phone number": "(651) 774-7955",
            "Fax Number": "651-774-1861",
            "Organization email": "sphac@sphac.org",
            "Organization website": "www.sphac.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "St-Paul-Hmong-Alliance-Church",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Chong Lee Yang ",
            "[contact_name]'s position": "Senior Pastor",
            "[contact_name]'s email": "xhntxoovlis@sphac.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Asian and Pacific Islander",
            "Please provide a description of services your organization offers": "Spiritual needs for the Christian Hmong community. Has a ministry for men, women, single adults, youth, and seniors.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Tibetan American Foundation of Minnesota",
            "Address": "1096 Raymond Ave. ",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55108",
            "County": "Ramsey",
            "Main phone number": "(651) 917-9556",
            "Fax Number": "612-917-9565",
            "Organization email": "office@tafm.org",
            "Organization website": "www.tafm.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": " TibetanCommunity",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Sonam Dhondup",
            "[contact_name]'s position": " President",
            "[contact_name]'s email": "sonamd@yahoo.com",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Asian and Pacific Islander",
            "Please provide a description of services your organization offers": "Assists Tibetans in Minnesota with resettlement and provides social services. Serves about 2500 to 3000 Tibetans.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "United Cambodian Association of MN, Inc",
            "Address": "1385 Mendota Heights Rd. ",
            "City": "Mendota Heights",
            "State": "MN",
            "Zip Code": "55102",
            "County": "Ramsey",
            "Main phone number": "(651) 255-0724",
            "Fax Number": " 651-222-3599",
            "Organization email": "info@ucamin.org",
            "Organization website": "https://www.ucamn.info/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Yorn Yan Executive",
            "[contact_name]'s position": " Director",
            "[contact_name]'s email": "yornyan@comcast.net",
            "[contact_name]'s phone number": "(651) 255-0724",
            "Second Contact name": "N Zan",
            "[contact_name_2]'s position": "Refugee Outreach Worker",
            "[contact_name_2]'s email": "nzan@ucaminc.org",
            "[contact_name_2]'s phone number": " 651-255-0723",
            "Please select what communities or groups you serve": "Asian and Pacific Islander",
            "Please provide a description of services your organization offers": "Promote health, social, economic and educational opportunities for all  Cambodians and new Americans living in Minnesota. Four areas of focus include: elderly independent living, youth development, health education and engagement, and immigration services.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Vietnamese Minnesotans Association",
            "Address": "1030 University Ave. W.",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55104",
            "County": "Ramsey",
            "Main phone number": "(651) 290-4791",
            "Fax Number": " 612-290-4785",
            "Organization email": "Vietassoc@aim.com",
            "Organization website": "https://www.vmamn.com/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Tinh Tran",
            "[contact_name]'s position": "",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Asian and Pacific Islander",
            "Please provide a description of services your organization offers": "Provides social services for Vietnamese and other people of Southeast Asia.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Vietnamese Social Services",
            "Address": "277 University Ave. W. ",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55103",
            "County": "Ramsey",
            "Main phone number": "(651) 641-8904",
            "Fax Number": "651-641-8908",
            "Organization email": "",
            "Organization website": " www.vssmn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Hue Pham",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "huetpham@vssmn.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "Peter Nguyen",
            "[contact_name_2]'s position": "Self-Sufficiency Program Manager",
            "[contact_name_2]'s email": "peter@vssmn.org",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Asian and Pacific Islander",
            "Please provide a description of services your organization offers": "VSS has bilingual staff that serve Vietnamese, Burmese/Karen, and Somali clients. We focus on health outreach (including information & referral to accessing health care), disease prevention, and job referrals/placement. VSS also offers ESL classes, elderly programs, youth programs (such as after school tutoring and workshops) to help at-risk youth succeed in school.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Minneapolis Jewish Federation",
            "Address": "111 Cheshire Ln, Suite 50",
            "City": "Minnetonka",
            "State": "MN",
            "Zip Code": "55305",
            "County": "Hennepin",
            "Main phone number": "(952) 593-2600",
            "Fax Number": "952-593-2544",
            "Organization email": "webmaster@mplsfed.org",
            "Organization website": "https://jewishminneapolis.org/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "jewishminneapolis",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Judie Rothschild",
            "[contact_name]'s position": "Director of Community Impact: Planning Allocations, & Community Partnerships",
            "[contact_name]'s email": "jrothschild@mplsfed.org",
            "[contact_name]'s phone number": "(952) 417-2356",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "European",
            "Please provide a description of services your organization offers": "We build community, care for the welfare of Jews everywhere and maximize participation in Jewish life. We accomplish this by planning, developing and allocating financial aid and human resources in partnership with Jewish institutions, locally and overseas.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Afro American Development Association",
            "Address": "1132 28th Avenue South, Suite 6",
            "City": "Moorhead",
            "State": "MN",
            "Zip Code": "56560",
            "County": "Clay",
            "Main phone number": "(218) 227-5220",
            "Fax Number": "",
            "Organization email": "info@aadevassoc.org",
            "Organization website": "https://www.aadevassoc.org/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Hukun Dabar",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "Hukun@aadevassoc.org",
            "[contact_name]'s phone number": "(701) 729-1001",
            "Second Contact name": "Cani Aden",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "cani.aden@aadevassoc.org",
            "[contact_name_2]'s phone number": "6124439032",
            "Please select what communities or groups you serve": "African (Immigrant)",
            "Please provide a description of services your organization offers": "AADA is the leading New American organization that empowering New Americans to integrate and thrive in MN/ND. Our Mission is to build the capacity of our grassroots beneficiaries in needs-based training, sustainable development, economic empowerment, conflict resolution & peacebuilding by promoting transformational development and gender empowerment.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Afro American Development Association",
            "Address": "1420 S Washington Ave",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55454",
            "County": "Hennepin",
            "Main phone number": "(218) 227-5220",
            "Fax Number": "",
            "Organization email": "info@aadevassoc.org",
            "Organization website": "https://www.aadevassoc.org/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Hukun Dabar",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "hukun@aadevassoc.org",
            "[contact_name]'s phone number": "(701) 729-1001",
            "Second Contact name": "Cani Aden",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "cani.aden@aadevassoc.org",
            "[contact_name_2]'s phone number": "6124439032",
            "Please select what communities or groups you serve": "African (Immigrant)",
            "Please provide a description of services your organization offers": "AADA is the leading New American organization that empowering New Americans to integrate and thrive in MN/ND. Our Mission is to build the capacity of our grassroots beneficiaries in needs-based training, sustainable development, economic empowerment, conflict resolution & peacebuilding by promoting transformational development and gender empowerment.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Asian Economic Development Association",
            "Address": "422 University Ave W, Ste 14",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55103",
            "County": "Ramsey",
            "Main phone number": "(651) 222-7798",
            "Fax Number": "",
            "Organization email": "info@aedamn.org",
            "Organization website": "http://aedamn.org/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "https://www.facebook.com/AEDA.org/",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Va-Megn Thoj",
            "[contact_name]'s position": "founder and executive director",
            "[contact_name]'s email": "",
            "[contact_name]'s phone number": "",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Asian and Pacific Islander",
            "Please provide a description of services your organization offers": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Centro Tyrone Guzman",
            "Address": "1915 Chicago Avenue ",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55404",
            "County": "Hennepin",
            "Main phone number": "(612) 874-1412",
            "Fax Number": "(612) 874-8149",
            "Organization email": "infocenter@centromn.org",
            "Organization website": "https://www.centromn.org/about/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "https://www.facebook.com/centrotyroneguzman/",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Roxana Linares",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "rlinares@centromn.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "Carolina Paredes",
            "[contact_name_2]'s position": "Program assistant",
            "[contact_name_2]'s email": "cparedes@centromn.org",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Latino/Latinx",
            "Please provide a description of services your organization offers": "",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": ""
        },
        {
            "Name of Organization": "Alight",
            "Address": "1325 Quincy Ave NE",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55413",
            "County": "Hennepin",
            "Main phone number": "(612) 872-7060",
            "Fax Number": "",
            "Organization email": "",
            "Organization website": "www.wearealight.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "https://www.facebook.com/WeAreAlight",
            "Instagram Page name": "",
            "Instagram Page Link": "https://www.instagram.com/we.are.alight/",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Annie Nolte-Henning",
            "[contact_name]'s position": "Director of the Americas",
            "[contact_name]'s email": "annien@wearealight.org",
            "[contact_name]'s phone number": "(612) 874-5467",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Alight is a non-profit organization, incorporated in 1978, working to build a meaningful life for and with the displaced. Alight's work includes providing health care, clean water, shelter, protection and other essential services to more than 3 million people each year. Alight believes there is simple human justice in the chance to build a life, and lives of dignity, connection, joy and purpose are what we aim for. ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "refugee, displaced, welcome, arrival, dignity, guidance, neighbor, guide, partner, navigation"
        },
        {
            "Name of Organization": "Missions Inc. Programs",
            "Address": "3409 E. Medicine Lake Blvd.",
            "City": "Plymouth",
            "State": "MN",
            "Zip Code": "55441",
            "County": "Hennepin",
            "Main phone number": "(763) 559-1883",
            "Fax Number": "763-559-1195",
            "Organization email": "",
            "Organization website": "www.missionsinc.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "MissionsInc",
            "Facebook Page link": "",
            "Instagram Page name": " @missionsincprog",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": " @missionsincprog",
            "Twitter Account link": "",
            "First Contact name": "Sarah Busch",
            "[contact_name]'s position": "Community Engagement & Outreach Coordinator",
            "[contact_name]'s email": "sbusch@missionsinc.org",
            "[contact_name]'s phone number": "(763) 545-7080",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Services to immigrant and refugee victims of domestic violence, including safe shelter, advocacy, information and support, and immigration-specific advocacy. All services are free, confidential, and voluntary, regardless of income or immigration status.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "domestic violence, advocacy, immigration"
        },
        {
            "Name of Organization": "Central Area Neighborhood Development Organization",
            "Address": "310 East 38th Street",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55409",
            "County": "Hennepin",
            "Main phone number": "(612) 353-6768",
            "Fax Number": "",
            "Organization email": "cando@thecentralneighborhood.com",
            "Organization website": "thecentralneighborhood.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "The Central Neighborhood Minneapolis Mn",
            "Facebook Page link": "",
            "Instagram Page name": "centralneighborhoodmlps",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Carmen Means",
            "[contact_name]'s position": "Executive Director ",
            "[contact_name]'s email": "carmen@thecentralneighborhood.",
            "[contact_name]'s phone number": "(612) 481-0787",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "To create a community that contains friendly open communication, and cooperation between neighbors. To stabilize and promote the integrated character of the neighborhood. To improve the quality of housing and surrounding environment. To lower the incidence of crime in the community. To determine the needs of the community and bring together community and outside organizations and individuals relevant to those needs.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "Central, Neighborhood, CANDO, Food Justice, PGS, Anti-Racism, Community"
        },
        {
            "Name of Organization": "Hispanic Outreach of Goodhue County",
            "Address": "1606 W 3rd St ",
            "City": "Red Wing",
            "State": "MN",
            "Zip Code": "55066",
            "County": "Goodhue",
            "Main phone number": "(651) 301-2184",
            "Fax Number": "",
            "Organization email": "info@hispanicoutreach.org",
            "Organization website": "www.hispanicoutreach.org ",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Lucy Richardson",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "lucy@hispanicoutreach.org ",
            "[contact_name]'s phone number": "(651) 301-2184",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,Latino/Latinx",
            "Please provide a description of services your organization offers": "Direct Services (interpreting, translation, notary, advocacy, read documents, filling out forms, emergency fund, finding resources such as housing, jobs, etc.)  After-school programs for grades 5-12   ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "Direct services, tutoring"
        },
        {
            "Name of Organization": "Hmong Home Health Care, LLC.",
            "Address": "475 Etna Street Ste 3",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55106",
            "County": "Ramsey",
            "Main phone number": "(651) 488-1680",
            "Fax Number": "",
            "Organization email": "contact@hh-hc.com",
            "Organization website": "www.hmonghomehealthcare.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Marcus Bradley",
            "[contact_name]'s position": "CEO",
            "[contact_name]'s email": "Marcus.Bradley@hh-hc.com",
            "[contact_name]'s phone number": "(651) 262-5514",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural",
            "Please provide a description of services your organization offers": "Personal Care Assistance (PCA) - Assist a client with their day to day personal care activities such as bathing, grooming, dressing, etc.      245D Waiver Programs - Assist client to regain or acquire independence in their home or community through personalized care and a person-centered focused. Provide level of care necessary to ensure the health and well-being of the client. Services includes; In-Home Respite, Night Supervision, Individualized Home Supports (IHS) with Family Training, Individualized Home Supports (IHS) with Training & Individualized Home Supports (IHS) without Training, Individual Community Living Supports (ICLS), & Homemaking.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "Home care agency, PCA, 245D Waiver Programs, Greater Twin Cities, Hmong/Asian Pacific, Karen, White, African-American, Hispanic/Latino, Diversity, Local, Caregivers, Family, Personalized-care, Community & Home-based, Clients, Person-centered, In-Home Respite, Night Supervision, IHS with Family Training, IHS with Training & IHS without Training, ICLS, & Homemaking."
        },
        {
            "Name of Organization": "Afghan Cultural Society",
            "Address": "301 Cedar Ave S",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55454",
            "County": "Hennepin",
            "Main phone number": "(612) 361-7111",
            "Fax Number": "",
            "Organization email": "info@afghanculturalsociety.org",
            "Organization website": "www.afghanculturalsociety.org ",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Nasreen Sajady",
            "[contact_name]'s position": "Advocacy Director",
            "[contact_name]'s email": "nasreen@afghanculturalsociety.org",
            "[contact_name]'s phone number": "",
            "Second Contact name": "Amina Baha",
            "[contact_name_2]'s position": "Operations Director",
            "[contact_name_2]'s email": "Amina@Afghanculturalsociety.org",
            "[contact_name_2]'s phone number": "(612) 386-1551",
            "Please select what communities or groups you serve": "Multicultural,Asian and Pacific Islander",
            "Please provide a description of services your organization offers": "Family social services, youth education and tutoring services, womens mental health services, culturally appropriate clothing closet, drop in center. ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "Afghan, Refugee, Immigrant, mental health, women, BIPOC, "
        },
        {
            "Name of Organization": "Mothers Tutoring Academy (MTA)",
            "Address": "1612 Como Avenue Ste B2",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55108",
            "County": "Ramsey",
            "Main phone number": "(651) 645-1111",
            "Fax Number": "",
            "Organization email": "ahmed.hassan@mtacenter.org",
            "Organization website": "www.mtacenter.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Ahmed Hassan",
            "[contact_name]'s position": "CEO",
            "[contact_name]'s email": "ahmed.hassan@mtacenter.org",
            "[contact_name]'s phone number": "(651) 815-7939",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant),Latino/Latinx",
            "Please provide a description of services your organization offers": "Mothers Tutoring Academy (MTA) is a non-profit, after-school tutoring, and community development institution.  We provide:  • Tutoring and mentoring to achieve a grade-level proficiency. • Parent Outreach and Networking to discuss: 1) the country's culture and school system. 2) Help inform parents where and how to apply for health insurance. 3) Inform parents the importance and benefits of teen checkup. 4) Help person(s) experiencing housing instability or homelessness and connect them with shelters.  5) Help person(s) with a substance use disorder and connect them to treatment centers.    • Create youth programs to help students resist bad behaviors and provide them positive chances.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "mtacenter.org,mothers tutoring academy,mta tutoring,tutoring services st paul,"
        },
        {
            "Name of Organization": "Canopy Mental Health & Consulting",
            "Address": "615 NE 1st Ave. Ste 505",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55413",
            "County": "Hennepin",
            "Main phone number": "(612) 712-7200",
            "Fax Number": "",
            "Organization email": "info@canopymhc.com",
            "Organization website": "www.canopymhc.com",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "https://www.facebook.com/canopymhc",
            "Instagram Page name": "",
            "Instagram Page Link": "https://www.instagram.com/canopymhc/?hl=en",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "https://twitter.com/canopymhc",
            "First Contact name": "Candace Hanson",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "info@canopymhc.com",
            "[contact_name]'s phone number": "(612) 712-7200",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant),Asian and Pacific Islander,European,Latino/Latinx",
            "Please provide a description of services your organization offers": "At Canopy Mental Health & Consulting you will find a variety of providers from psychologists, marriage and family therapists, clinical social workers, to licensed professional counselors. We are dedicated to providing high-quality mental health services with purpose and integrity by embracing the unique needs of individuals, groups, families, and communities. Our approach to healing is informed by collective knowledge and resources, identification of natural and cultural strengths, and affirmation of dignity.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "mental health, trauma, therapy, family therapy, couples counseling, relationship psychotherapy, multicultural psychotherapy, medication management"
        },
        {
            "Name of Organization": "Southwestern Minnesota Opportunity Council, Inc",
            "Address": "909 4th Ave",
            "City": "Worthington",
            "State": "MN",
            "Zip Code": "56187",
            "County": "Nobles",
            "Main phone number": "(800) 658-2444",
            "Fax Number": "",
            "Organization email": "info@smoc.us",
            "Organization website": "www.smoc.us",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Katie Kuehl",
            "[contact_name]'s position": "RN",
            "[contact_name]'s email": "kkuehl@smoc.us",
            "[contact_name]'s phone number": "(507) 537-1950",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant),Asian and Pacific Islander,European,Latino/Latinx",
            "Please provide a description of services your organization offers": "Child care aware, early learning scholarships, energy assistance, family planning, head start, homemakers program, housing loan program, senior community service program, transportaion, weatherization program",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "community action, SMOC, energy, family planning, housing, transportation, weatherization"
        },
        {
            "Name of Organization": "Chinese Community Center",
            "Address": "12160 Technology Dr,",
            "City": "Eden Prairie",
            "State": "MN",
            "Zip Code": "55344",
            "County": "Hennepin",
            "Main phone number": "(952) 222-8884",
            "Fax Number": "",
            "Organization email": "info@cccminnesota.org",
            "Organization website": "https://www.cccminnesota.org/",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "CCCMinnesota",
            "Facebook Page link": "https://www.facebook.com/CCCMinnesota",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Melody Zhou",
            "[contact_name]'s position": "Executive Director",
            "[contact_name]'s email": "melody.zhou@cccminnesota.org",
            "[contact_name]'s phone number": "(612) 618-0067",
            "Second Contact name": "Xinyun Zhu",
            "[contact_name_2]'s position": "Director",
            "[contact_name_2]'s email": "xinyun.zhu@cccminnesota.org",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,Refugee Resettlement Agency,Asian and Pacific Islander,People with disabilities,LGBTQ+",
            "Please provide a description of services your organization offers": "Chinese Community Center is organized exclusively for charitable, scientific and education purposes. The purpose of this corporation is to promote the cultural, educational, recreational, and social welfare of the residents of Chinese heritage of the State of Minnesota, and of the general public.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "Chinese Community Center is founded and led by Chinese Americans. Our mission is to promote the cultural, educational, recreational, and social welfare of the residents of Chinese heritage of the State of Minnesota, and of the general public.     We worked very closely with different organizations during the pandemic to serve all communities. We worked with more than 40 organizations during #Stop Asian Hate# Commemoration Rally, including those of Thai, Hmong, Japanese, Karen, Korean, Tibetan, Indian and Vietnamese descent. Working with partners across a wide range of ethnicities allows us to include a diverse range of voices in our decision-making and contribute to a more equitable society."
        },
        {
            "Name of Organization": "Phyllis Wheatley Community Center",
            "Address": "1301 N. 10th Avenue",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55411",
            "County": "Hennepin",
            "Main phone number": "(612) 374-4342",
            "Fax Number": "",
            "Organization email": "info@phylliswheatley.org",
            "Organization website": "www.phylliswheatley.org",
            "Supplemental Address": "1301 N. 10th Avenue",
            "Supplemental City": "Minneapolis",
            "Supplemental State": "MN",
            "Supplemental Zip Code": "55411",
            "Supplemental County": "Hennepin",
            "Supplemental Phone Number": "(612) 374-4342",
            "Supplemental Organization Website ": "https://www.phylliswheatley.org/",
            "Facebook Page name": "Phyllis Wheatley Community Center",
            "Facebook Page link": "https://www.facebook.com/PWCCmpls",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "Phyllis Wheatley Community Center",
            "YouTube Account link": "https://www.youtube.com/channel/UCwIkxqDS4oixgFV4QYr3etA",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Katy Nelson",
            "[contact_name]'s position": "Senior Director of Development & Communications",
            "[contact_name]'s email": "katyn@phylliswheatley.org",
            "[contact_name]'s phone number": "(612) 374-4342",
            "Second Contact name": "Amondo Dickerson",
            "[contact_name_2]'s position": "Operations Manager",
            "[contact_name_2]'s email": "AmondoD@phylliswheatley.org",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "African American",
            "Please provide a description of services your organization offers": "We provide holistic services for the entire family or individual, including affordable early childhood education, restorative programs for families who have been separated and restorative programs for people who have been involved in the justice system, youth development, recreation, and summer camp, and women's wealth equity, among others. Our goal to create access and equity of opportunity for the people of North Minneapolis. ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "African American, Community Center, North Minneapolis, HOPE programs, Mary T. Wellcome, Camp Katharine Parsons"
        },
        {
            "Name of Organization": "East African Integration Center",
            "Address": "1911 Nicollet Ave Ste 10-7",
            "City": "Minneapolis",
            "State": "MN",
            "Zip Code": "55403",
            "County": "Hennepin",
            "Main phone number": "(612) 324-3286",
            "Fax Number": "",
            "Organization email": "info@eafricic.org",
            "Organization website": "eafricic.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Mohamed Daher",
            "[contact_name]'s position": "ED",
            "[contact_name]'s email": "mdaher@eafricic.org",
            "[contact_name]'s phone number": "(612) 324-3286",
            "Second Contact name": "Ahmed Bule ",
            "[contact_name_2]'s position": "Programs director ",
            "[contact_name_2]'s email": "abule@eafricic.org",
            "[contact_name_2]'s phone number": "6123243286",
            "Please select what communities or groups you serve": "Multicultural,African (Immigrant)",
            "Please provide a description of services your organization offers": "The East African Integration Center provides a range of services to the community, including:    Social Services: Offering support and assistance to individuals and families in need, including counseling, case management, and access to community resources.    Employment Services: Assisting community members with job searches, resume writing, interview preparation, and connecting them with potential employers.    COVID-19 Vaccine Events: Organizing events to provide information about the COVID-19 vaccine and offering vaccination services to community members.    Comprehensive Recovery After COVID-19: Providing support and resources to individuals and families affected by COVID-19, including recovery services, mental health support, and financial assistance.    Other Resources: Offering a variety of other resources and services to support the well-being and integration of the East African community, such as educational programs, legal assistance, and provide assistance other immigration resources.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "Social services  Employment services  COVID-19 vaccine  Recovery services  Community resources  Job search  Resume writing  Interview preparation  Mental health support  Filling forms"
        },
        {
            "Name of Organization": "Restoration for All Inc.",
            "Address": "1870 50th Street E Suite #10 ",
            "City": "Inver Grove Heights",
            "State": "MN",
            "Zip Code": "55077",
            "County": "Dakota",
            "Main phone number": "(651) 366-0279",
            "Fax Number": "",
            "Organization email": "tmola@restoreall.org",
            "Organization website": "https://www.restoreall.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "restorationforall",
            "Facebook Page link": "https://www.facebook.com/restorationforall",
            "Instagram Page name": "restoration4all",
            "Instagram Page Link": "https://www.instagram.com/restoration4all/",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": " @restoration_for",
            "Twitter Account link": "https://twitter.com/restoration_for",
            "First Contact name": "Tolulope Ola",
            "[contact_name]'s position": "Founder & Executive Director",
            "[contact_name]'s email": "tmola@restoreall.org ",
            "[contact_name]'s phone number": "(651) 366-0279",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "Multicultural,Refugee Resettlement Agency,African (Immigrant)",
            "Please provide a description of services your organization offers": "Restoration for All Inc. is an organization that partners with individuals and communities to restore their cultural connections by addressing trauma, promoting socio-cultural well-being, and resilient connections.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "COVID-19 Vaccination Clinic, Family, Friends, and Neighbors (FFN) Providers Program, After School Program, Dementia Program, Culturally specific and relevant Mental Health Services, Cultural Healing Practices, Elderly Cultural Fitness & Wellness Services"
        },
        {
            "Name of Organization": "Raíces Sagradas Community Mental Health",
            "Address": "490 Hall Ave",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55107",
            "County": "Ramsey",
            "Main phone number": "(612) 405-8014",
            "Fax Number": "",
            "Organization email": "raices.intake@gmail.com",
            "Organization website": "www.raicessagradas.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Maria Cervantes",
            "[contact_name]'s position": "Associate Director",
            "[contact_name]'s email": "raices.cervantesm@gmail.com",
            "[contact_name]'s phone number": "(612) 440-0918",
            "Second Contact name": "Cecilia Martinez",
            "[contact_name_2]'s position": "Intake Coordinator",
            "[contact_name_2]'s email": "raices.intake@gmail.com",
            "[contact_name_2]'s phone number": "(612) 405-8014",
            "Please select what communities or groups you serve": "Latino/Latinx",
            "Please provide a description of services your organization offers": "Raíces Sagradas provides direct, culturally sensitive professional psychotherapy services to individuals, couples, and families in Spanish and English. We also do psychological evaluations necessary for immigration legal processes.    In addition to clinical services, we train community members on the basics of trauma, depression, and anxiety. This training enables us to integrate current and helpful information and referrals into church and community offerings.    Raíces Sagradas brinda servicios de psicoterapia profesional directos y culturalmente sensibles a individuos, parejas y familias en español e inglés. También hacemos evaluaciones psicológicas necesarias para procesos legales de inmigración.    Además de los servicios clínicos, capacitamos a los miembros de la comunidad sobre los conceptos básicos del trauma, la depresión y la ansiedad. Esta capacitación nos permite integrar información y referencias actuales y útiles en las ofertas de la iglesia y la comunidad.",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "culturally sensitive psychotherapy, psychological evaluations immigration refugees trauma, depression, anxiety, training, community workshops, therapy, couple counseling, family therapy, individual therapy, compassionate mental health services, stigma, end stigma, language, and cultural barriers."
        },
        {
            "Name of Organization": "Heritage Organization of Romanian Americans in Minnesota ",
            "Address": "319 landmark center 75 west fifth st",
            "City": "St. Paul",
            "State": "MN",
            "Zip Code": "55102",
            "County": "Ramsey",
            "Main phone number": "(952) 210-8058",
            "Fax Number": "",
            "Organization email": "Horamn.media@gmail.com",
            "Organization website": "Hora-mn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Dana Voller",
            "[contact_name]'s position": "President",
            "[contact_name]'s email": "Horamn.media@gmail.com",
            "[contact_name]'s phone number": "(952) 210-8058",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "European",
            "Please provide a description of services your organization offers": "We are are a cultural organization focused on sharing and preserving Romanian heritage. ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "Romanian, heritage, Romanian-American, Moldovan, art, culture, immigration"
        },
        {
            "Name of Organization": "Women's Wellness & Parenting Support Center",
            "Address": "8500 Normandale Lake Blvd Suite 350",
            "City": "Bloomington",
            "State": "MN",
            "Zip Code": "55437",
            "County": "Hennepin",
            "Main phone number": "(612) 293-7697",
            "Fax Number": "(952) 666 - 1137",
            "Organization email": "wwpscmn@gmail.com",
            "Organization website": "https://www.wwpscmn.org",
            "Supplemental Address": "",
            "Supplemental City": "",
            "Supplemental State": "",
            "Supplemental Zip Code": "",
            "Supplemental County": "",
            "Supplemental Phone Number": "",
            "Supplemental Organization Website ": "",
            "Facebook Page name": "",
            "Facebook Page link": "",
            "Instagram Page name": "",
            "Instagram Page Link": "",
            "YouTube Account name": "",
            "YouTube Account link": "",
            "Twitter Account name": "",
            "Twitter Account link": "",
            "First Contact name": "Niema Ismael",
            "[contact_name]'s position": "Executive Director ",
            "[contact_name]'s email": "Niemaahmed41@gmail.com",
            "[contact_name]'s phone number": "(952) 594-4711",
            "Second Contact name": "",
            "[contact_name_2]'s position": "",
            "[contact_name_2]'s email": "",
            "[contact_name_2]'s phone number": "",
            "Please select what communities or groups you serve": "African (Immigrant)",
            "Please provide a description of services your organization offers": "Women's Wellness & Parenting Support Center (WWPSC) is a 501(C3) nonprofit founded in 2022 to empower Somali women. We offer tailored programs for women and children focusing on mental health, wellness, and parenting skills, addressing issues like anxiety, depression, trauma, and domestic violence, with support for challenges such as ADHD, early childhood mental health, and family therapy.  ",
            "Please list any and all keywords that would help describe and search your organization and the services you provide. ": "Womens Health, Adult and children's mental health, East African, Psycho-Education Programs, Anxiety,  Depression, Suicidal Thoughts, Self Harm, Grief and Loss, Trauma and Abuse, Racism and Injustice Related Support, Attention-Deficit/Hyperactivity Disorder (ADHD), Early Childhood Mental Health  Childrens Mental Health, School Difficulties, Divorce, Domestic Violence, Relationship Issues, Trauma and PTSD, Parenting Support, Family therapy, Anger Management"
        }
    ]
export default maacboData;
